export const appConfig = {
  LOGIN: "secure/login",
  FILE_GET: "file/list/get",
  RT_FILE_GET: "file/rt/list/get",

  ////////////////////////////get///////////////////////////
  TOTAL_GET_AUM: "backoffice/clientTotalAum/get",
  GET_MIS_DATA: "backoffice/mis/get",
  GET_SUBCAT_AUM: "backoffice/cat/subcat/get",
  GET_SUBCAT_SCHEMENAME: "backoffice/cat/subcat/scheme",
  GET_TOTAL_SCHEME_AUM: "asset/schemeTotalAum/get",
  GET_TOTAL_AUM_BY_SCHEME: "asset/schemeTotalAum/get",
  GET_CLIENT_WISE_TOTALAUM: "asset/report/client/totalaum/get",
  GET_SIP_COUNT_GET: "backoffice/sip/count/get",
  GET_AUM_APPLICANT: "backoffice/aum/applicantWise/totalaum/applicantName/get",
  GET_AUM_APPLICANT_CATEGORY:
    "backoffice/aum/applicantWise/totalaum/applicantsAllCategory/get",
  GET_AUM_APPLICANT_SUB_CATEGORY:
    "backoffice/aum/applicantWise/totalaum/applicantSubCategory/get",
  GET_AUM_APPLICANT_SCHEME:
    "backoffice/aum/applicantWise/totalaum/applicantSchemes/get",
  GET_AUM_CLIENT_TOTALAUM: "backoffice/aum/client/totalaum/get",
  GET_AUM_FAMILY_MEMBER: "backoffice/aum/client/familymember",
  GET_AUM_FAMILY_SCHEME: "backoffice/aum/client/familymember/scheme",
  GET_AUM_FAMILY_SCHEME_FOLIO:
    "backoffice/aum/client/familymember/scheme/folio",
  GET_AUM_CLIENT_SCHEME: "backoffice/aum/client/schemes",
  GET_CLIENT_FOLIO_WISE: "asset/cat/subcat/schemeName/clientFolioWise",
  GET_AMC_WISE: "backoffice/mis/aum/amcWise/get",
  GET_APPLICANT_NAME: "backoffice/mis/aum/amcWise/applicantName/get",
  ADVISOR_TAG_GET: "advisor/tag/get",
  AUM_GRAPH_GET: "backoffice/aum/graph/details/get",
  ARN_RIA_LIST: "backoffice/arn/ria/list/get",
  RM_LOGIN: "rmdashboard/rm/sign-in",
  RM_MAPPED_UNMAPPED_SCHEME_COUNT_NJ_PRUDENT:
    "rmdashboard/count/mapped/unmapped/schemes",
  ADD_CEASED_DATE: "backoffice/cease/date/add",
  CLIENT_WITHOUT_MF: "backoffice/clientWithoutMf/get",
  GET_SCHEME_LIST_MIS_AUM: "backoffice/scheme/list/get",
  RM_UNMAP_MAPPED_NJPRUDENT_SCHEMES: "rmdashboard/unmap/njprudent/schemes",
  RM_MAP_UNMAPPED_NJPRUDENT_SCHEMES: "rmdashboard/map/njprudent/schemes",
  GET_MF_TRANSACTIONS: "mutual-fund/mutualFundTransaction/list/get",
  FILTER_DATA: "mutual-fund/mutualFundTransaction/filtered/list/get",
  SEARCH_DATA: "",
  GET_CAT_LIST_MIS_AUM: "backoffice/sub-category/list/get",
  GET_CAT_SUBCAT_LIST_MIS_AUM: "/backoffice/cat/subcat/get",
  GET_LOG: "mutual-fund/report/mf-report/client-log/get",
  MAP_CLIENT: "user/client/advisor/map/multiple",
  GET_SEGREGATED_SCHEME_MAP: "mutual-fund/get/segregated/scheme/mapped",
  GET_SEGREGATED_SCHEME_UNMAP: "mutual-fund/get/segregated/scheme/unmapped",
  GET_NON_SEGREGATED_SCHEME: "mutual-fund/get/nonsegregated/schemes",
  MAP_SEGREGATED_SCHEME: "mutual-fund/map/segregated/schemes",
  UNMAP_SEGREGATED_SCHEME: "mutual-fund/unmap/segregated/schemes",
  UPDATE_SCHEME_DATE: "mutual-fund/update/segregated/date",
  GET_MAPPED_COUNT: "mutual-fund/get/segregated/scheme/mapped/count",
  GET_UNMAPPED_COUNT: "mutual-fund/get/segregated/scheme/unmapped/count",
  GET_TRANSACTION_LOGS: "bse/order/transactionLogs",
  GET_TRANSACTION_COUNT: "bse/order/TransactionCount",
  GET_ACCORD_DATA: "accord/scheme/detail/update/status/list/get",
  GET_ONBOARDING_OPTIONS:
    "rmdashboard/ifa/onboarding/questionOption/master/get",
  GET_ONBOARDING_ANSWERS: "rmdashboard/myifas/onboarding/details/get",
  GET_ONBOARDING_ANSWERS_UPDATE: "rmdashboard/myifas/onboarding/details/update",
  CALL_DONE_SCHEDULECALL: "rmdashboard/myifas/onboarding/calldetails/update",
  GET_ONBOARDING_TEMPLATE_LIST: "interakt/templateList/get",
  GET_INTERAKT_TEAMMEMBER_LIST: "interakt/teamMember/get",
  POST_INTERAKT_TEMPLATES: "interakt/sendTemplateMessages",
  DOWNLOAD_FILES: "file/download-url/get",

  GET_FILTER_NEW_MYIFAS_LIST:
    "rmdashboard/myifas/dashboard/details/new/Filter/get",
  DELETE_ONBOARDING_COMMENT_BY_ID_: "rmdashboard/ifa/onboarding/comment/delete",

  ///////////////////foliodetails///////////////////////////
  FOLIO_GROUP_HEAD_SEARCH: "backoffice/folio/search/by/groupHead/get",
  FOLIO_INVESTOR_SEARCH: "backoffice/folio/search/by/investorName/get",
  FOLIO_PAN_SEARCH: "backoffice/folio/search/by/pan/get",
  FOLIO_FOLIO_NO__SEARCH: "backoffice/folio/search/by/folioNumber/get",
  FOLIO_GROUP_HEAD_LIST: "backoffice/foliowise/groupHead/list/get",
  FOLIO_APPLICANT_NAME_LIST: "backoffice/foliowise/applicaName/list/get",

  /////////////////////// sip api call//////////////////////////////////
  GET_NEW_SIP: "backoffice/sip/new/sip/get",
  GET_CEASE_SIP: "backoffice/sip/ceased/sip/get",
  GET_EXPIRING: "backoffice/sip/expiring/get",
  GET_expired: "backoffice/sip/expired/get",
  GET_SIP_REJECTION: "backoffice/sip/sipRejection/get",
  GET_SIP_client_SEARCH: "backoffice/sip/client/search/get",
  GET_SIP_SCHEME_SEARCH: "backoffice/sip/scheme/search/get",

  GET_SIP_AMC: "backoffice/sip/amc/get",
  GET_SIP_AMC_SCHEME: "backoffice/sip/amc/scheme/get",
  GET_SIP_INVERSTORS: "backoffice/sip/scheme/investors/get",
  Scheme_Investors_Applicants: "backoffice/sip/scheme/investors/applicants/get",
  Sip_Schemewise_Get: "backoffice/sip/schemewise/get",
  Scheme_Wise_Investor_Get: "backoffice/sip/schemewiseInvestor/get",
  scheme_wise_Applicants_Get: "backoffice/sip/schemewiseApplicants/get",
  ALL_SIP_GET: "backoffice/sip/allSip/get",
  CLIENT_WISE_CLIENTNAME_GET: "backoffice/sip/ClientWiseClientsName/get",
  CLIENT_WISE_APPLICANT_GET: "backoffice/sip/ClientWiseApplicants/get",
  SIP_PAN_COUNT: "backoffice/sip/scheme/pan/count/get",
  WBR_FOLIO_PAN_COUNT: "backoffice/folio/pan/count/get",
  SIP_APPLICANT_LIST: "backoffice/sip/applicant/list/get",
  SIP_FOLIO_LIST: "backoffice/sip/applicant/scheme/folio/list/get",
  SIP_CLEANUP_TRANSACTION_GET: "backoffice/sip-cleanup/mf-transaction/list/get",

  ///////////////////////////// rm dashboard ///////////////////////////////////////////
  RM_DASHBOARD_RM_MASTER_USER_GET: "rmdashboard/dashboard/rm-master/user/get",
  RM_SEARCH_NJ_PRUDENT_SCHEMES: "rmdashboard/get/filtered/njprudent/schemes",
  DELETE_SIP: "admin/dashboard/mf-sip/reset",
  REFRESH_DASHBOARD: "admin/dashboard/key/metrics/refresh",
  RM_DASHBOARD_MISC_SENDY_FILE_URL_GET: "misc/sendy-excel/upload-url/get",
  RM_DASHBOARD_POST_AFTER_SENDY_FILE_UPLOAD: "misc/sendy/subscribe/excel",
  ADD_SCRIP_STOCK: "account/asset/ops-team/stock/scrip/add",
  GET_SIGNZY_KYC_UPDATE: "user/client/kyc-status/check",
  BILLING_INVOICE_DETAILS: "user/advisor/invoice/details/get",
  BILLING_INVOICE_UPDATE: "user/advisor/add-remove/advisor/credit-points",
  GET_GST_DATA: "user/advisor/advisor-billing-detail/get",
  GET_SIGNZY_KYC_UPDATE_SEND: "user/client/signzy/send/email",
  EMPANEL_DETAILS: "account/liability/support/empanel/detail/get",
  EMPANEL_REFFERER_DETAILS:
    "account/liability/support/empanel/refferer/details/get",
  EMPANEL_INTEREST_RATE: "account/liability/support/empanel/interest/list/get",
  EMPANEL_DETAILS_UPDATE: "account/liability/support/empanel/refferer/add",
  EMPANEL_CHECK: "account/liability/support/empanel/refferer/check",
  DUPLICATION_CHECK:
    "account/liability/support/empanel/unityUserId/duplication",
  MAX_WALLET_USE: "user/advisor/credit-point-used/add",
  REGISTER_WAIVER_DEADLINE: "user/advisor/registration-waiver/add",
  ///////////////////////////// back office/////////////////////////////////////////////

  AllClient_get: "asset/allClient/get",
  AllClient_ByName_get: "asset/allClient/ByName/get",
  AllClient_ByTags_get: "asset/allClient/ByTags/get",
  Update_expiryDate: "asset/update/expiryDate",
  Update_Password: "asset/update/password",
  Fileorder_Status_Report_Get: "asset/fileorder/status/report/get",
  BACKOFFICE_MIS_AUM_GET_RT_LIST: "backoffice/mis/aum/rta/get",
  ///////////////////////////////BULK EMAIL///////////////////////////////
  GET_CLIENT_ADVISOR_DEATILS:
    "/backoffice/bulk-report/advisor-client/detail/get",
  GET_CLIENT_COUNT: "mutual-fund/report/client-count/get",
  HTML_TO_PDF: "pdfAndEmail/bulk-mail/html-to-pdf",
  GET_CLIENT_IN_LOOP: "mutual-fund/report/bulk-order/save",
  GET_ORDER_LIST: "mutual-fund/report/bulk-order/list/get",
  REFRESH_COUNT: "mutual-fund/report/bulk-order/refresh",
  GET_MF_CLIENTS: "mutual-fund/report/client-setting/list/get",
  SAVE_SETTING: "mutual-fund/report/client-setting/edit",
  SAVE_SETTING_ALL: "mutual-fund/report/all-client/reportwise/customize",
  GET_MUTUAL_FUND_UNMAP_FOLIO_SCHEME_NAME_LIST:
    "mutual-fund/unmap/folio/scheme-name/list/get",
  GET_MUTUAL_FUND_ALL_FOLIO_SCHEME_NAME_LIST:
    "mutual-fund/folio/search/list/get",

  GET_MUTUAL_FUND_UNMAP_FOLIO_LIST: "mutual-fund/unmap/folio/list/get",
  GET_MUTUALFUND_UNMAP_USER_DETAIL_LIST:
    "mutual-fund/unmap/folio/user-detail/list/get",
  PUT_MUTUALFUND_UNMAP_INVESTOR_DETAIL_UPDATE:
    "mutual-fund/unmap/investor-detail/update",
  GET_MUTUAL_FUND_NOMINEE_FOLIO_SCHEME_WISE_DATA:
    "mutual-fund/nominee/folio-scheme-wise/get",
  GET_SIP_WIZARD_COUNT: "backoffice/sip-wizard/total-sip-count/get",
  RUN_WIZARD: "backoffice/sip-wizard/run",
  PREVIOUS_WIZARD_LOG: "backoffice/sip-wizard/history/get",
  CURRENT_WIZARD_LOG: "backoffice/sip-wizard/latest-log/get",
  REFRESH_WIZARD: "backoffice/sip-wizard-log/refresh",
  GET_MUTUAL_FUND_SIP_CLEANUP_LIST: "mutual-fund/sip-cleanup/list/get",
  // GET_MUTUAL_FUND_SIP_CLEANUP_LIST: 'backoffice/sip-cleanup/list/get',
  PUT_MUTUAL_FUND_SIP_CLEANUP_REMOVE_STATUS_UPDATE:
    "mutual-fund/sip-cleanup/remove/status/update",
  // PUT_MUTUAL_FUND_SIP_CLEANUP_REMOVE_STATUS_UPDATE: 'backoffice/sip-cleanup/remove/status/update',
  /////////////////////////////Accounts///////////////////////////////////
  ADD_FIXEDDEPOSIT: "account/asset/fixed-income/fixed-deposit/add",
  ADD_LIFE_INSURANCE: "account/insurance/life-insurance/add",
  DELETE_LIFE_INSURANCE: "account/insurance/life-insurance/delete",
  GET_LIFE_INSURANCE: "account/insurance/list/get",
  GET_GLOBAL_INSURANCE: "account/insurance/global-list/get",
  EDIT_LIFE_INSURANCE: "account/insurance/life-insurance/edit",
  GET_INSURANCE_GLOBAL_API: "account/insurance/global/get",
  ADD_OTHER_INSURANCE: "account/insurance/other/add",
  EDIT_OTHER_INSURANCE: "account/insurance/other/edit",
  DELETE_OTHER_INSURANCE: "account/insurance/other/delete?",
  DELETE_OTHER_ADDON: "account/insurance/other-insurance/addon/delete?",
  DELETE_OTHER_FEATURE: "account/insurance/other-insurance/feature/delete?",
  DELETE_OTHER_MEMBER: "account/insurance/other-insurance/member/delete?",
  DELETE_OTHER_NOMINEE: "account/insurance/delete/nominee?",
  GET_OTHER_INSURANCE: "account/insurance/other/list/get",

  ADD_GENERAL_INSURANCE: "account/insurance/general-insurance/add",
  EDIT_GENERAL_INSURANCE: "account/insurance/general-insurance/edit",
  GET_GENERAL_INSURANCE: "account/insurance/general-insurance/list/get",
  DELETE_GENERAL_INSURANCE: "account/insurance/general-insurance/delete",
  INSURANCE_COUNT_GET: "account/insurance/count/list",
  GET_INCOME_COUNT: "account/income/count/get",
  GET_BUDGET_COUNT: "account/expense/budget/count/get",
  GET_EXPENSE_COUNT: "account/expense/count/get",
  COMPANY_LIST_GET: "account/insurance/company/list/get",
  ADD_LIABILITY: "account/liability/loan/add",
  GET_LIABILITY: "account/liability/loan/list/get",
  EDIT_LIABILITY: "account/liability/loan/edit",
  CALCULATE_EMI: "account/liability/calculate/emi",
  EDIT_FIXEDDEPOSIT: "account/asset/fixed-income/fixed-deposit/edit",
  GET_LIST_FAMILY_MEMBER: "account/income/family-members/get",
  GET_FIXEDDEPOSIT: "account/asset/fixed-income/fixed-deposit/get",
  GET_RECURING_DEPOSIT: "account/asset/fixed-income/recurring-deposit/list/get",
  GET_BONDS: "account/asset/fixed-income/bond/list/get",
  ADD_RECURRING_DEPOSIT: "account/asset/fixed-income/recurring-deposit/add",
  ADD_BOND: "account/asset/fixed-income/bond/add",
  EDIT_RECURRING_DEPOSIT: "account/asset/fixed-income/recurring-deposit/edit",
  EDIT_BONDS: "account/asset/fixed-income/bond/edit",
  GET_GLOBAl: "account/asset/nps/global-data/get",
  GET_BANK_ACCOUNTS: "account/asset/bank-account/list/get",
  ADD_BANK_ACCOUNTS: "account/asset/bank-account/add",
  EDIT_BANK_ACCOUNTS: "account/asset/bank-account/edit",
  GET_CASH_IN_HAND: "account/asset/cash-in-hand/list/get",
  ADD_CASH_IN_HAND: "account/asset/cash-in-hand/add",
  EDIT_CASH_IN_HAND: "account/asset/cash-in-hand/edit",
  GET_GOLD: "account/asset/commodity/gold/list/get",
  ADD_GOLD: "account/asset/commodity/gold/add",
  EDIT_GOLD: "account/asset/commodity/gold/edit",
  GET_OTHERS: "account/asset/commodity/other/list/get",
  ADD_OTHERS: "account/asset/commodity/other/add",
  EDIT_OTHERS: "account/asset/commodity/other/edit",
  GET_ASSET_SMALL_SAVING_SCHEME_PPF: "account/asset/ssc/ppf/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_NSC: "account/asset/ssc/nsc/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_SSY: "account/asset/ssc/ssy/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_KVP: "account/asset/ssc/kvp/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_SCSS: "account/asset/ssc/scss/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_POSAVING:
    "account/asset/saving-scheme/po-saving/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_PO_RD: "account/asset/ssc/pord/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_PO_TD: "account/asset/ssc/po-td/list/get",
  GET_ASSET_SMALL_SAVING_SCHEME_PO_MIS: "account/asset/ssc/po-mis/list/get",
  ADD_OTHER_PAYABLES: "account/liability/otherpayables/add",
  EDIT_OTHER_PAYABLES: "account/liability/otherpayables/edit",
  ADD_REAL_ESTATE: "account/asset/real-estate/add",
  EDIT_REAL_ESTATE: "account/asset/real-estate/edit",
  ADD_OTHERS_ASSETS: "account/asset/other-asset/add",
  EDIT_OTHERS_ASSETS: "account/asset/other-asset/edit",
  ADD_SOVEREIGN_GOLD_BOND: "account/asset/sovereign-gold/add",
  EDIT_SOVEREIGN_GOLD_BOND: "account/asset/sovereign-gold/edit",
  GET_SOVEREIGN_GOLD_BOND: "account/asset/sovereign-gold/list/get",
  GET_SOVEREIGN_GOLD_BOND_ISSUE_PRICE:
    "account/asset/sovereign-gold-issue-price/get",
  DELETE_SOVEREIGN_GOLD_BOND_TRANSACTION:
    "account/asset/sovereign-gold-transaction/delete",
  DELETE_SOVEREIGN_GOLD_BOND: "account/asset/sovereign-gold/delete",
  ADD_PPF_SCHEME: "account/asset/saving-scheme/ppf/add",
  ADD_NSC_SCHEME: "account/asset/saving-scheme/nsc/add",
  ADD_SSY_SCHEME: "account/asset/saving-scheme/ssy/add",
  ADD_SCSS_SCHEME: "account/asset/saving-scheme/scss/add",
  ADD_PO_SAVING: "account/asset/saving-scheme/po-saving/add",
  ADD_PO_RD_SCHEME: "account/asset/saving-scheme/pord/add",
  EDIT_NSC_SCHEME: "account/asset/saving-scheme/nsc/edit",
  EDIT_SSY_SCHEME: "account/asset/saving-scheme/ssy/edit",
  EDIT_SCSS_SCHEME: "account/asset/saving-scheme/scss/edit",
  EDIT_POSAVING_SCHEME: "account/asset/saving-scheme/po-saving/edit",
  ADD_POMIS: "account/asset/saving-scheme/pomis/add",
  EDIT_POMIS: "account/asset/saving-scheme/pomis/edit",
  EDIT_PPF_SCHEME: "account/asset/saving-scheme/ppf/edit",
  ADD_KVP_SCHEME: "account/asset/saving-scheme/kvp/add",
  EDIT_KVP_SCHEME: "account/asset/saving-scheme/kvp/edit",
  EDIT_PORD_SCHEME: "account/asset/saving-scheme/pord/edit",
  ADD_POTD_SCHEME: "account/asset/saving-scheme/potd/add",
  EDIT_POTD_SCHEME: "account/asset/saving-scheme/potd/edit",
  GET_ASSET_COUNT_GLOBAL_DATA: "account/asset/count/list",
  GET_AUM_GRAPH_DATA: "account/asset/client/aum/graph-data/get",
  DELETE_PPF_SCHEME: "account/asset/saving-scheme/ppf/delete",
  DELETE_NSC_SCHEME: "account/asset/saving-scheme/nsc/delete",
  DELETE_SSY_SCHEME: "account/asset/saving-scheme/ssy/delete",
  DELETE_KVP_SCHEME: "account/asset/saving-scheme/kvp/delete",
  DELETE_SCSS_SCHEME: "account/asset/saving-scheme/scss/delete",
  DELETE_POSAVING_SCHEME: "account/asset/saving-scheme/po-saving/delete",
  DELETE_PORD_SCHEME: "account/asset/saving-scheme/pord/delete",
  DELETE_POTD_SCHEME: "account/asset/saving-scheme/potd/delete",
  DELETE_POMIS_SCHEME: "account/asset/saving-scheme/pomis/delete",
  GET_POLICY_NAME: "account/insurance/policy-list/get",
  DELETE_INSURANCE: "account/insurance/life-insurance/delete",
  DELETE_REAL_ESTATE: "account/asset/real-estate/delete",
  DELETE_OTHERS_ASSETS: "account/asset/other-asset/delete",
  DELETE_OTHER_PAYABLES: "account/liability/otherpayables/delete",
  DELETE_LIABILITIES: "account/liability/loan/delete",
  GET_ALL_FILES: "document/account/document/all-file/get",
  DOWNLOAD_FILE: "document/account/document/all-file/file/get",
  DELETE_FILE: "document/account/document/all-file/file/trash",
  MOVE_FILES: "document/account/document/all-file/file/move",
  MOVE_FOLDER: "document/account/document/all-file/folder/move",
  COPY_FILES: "document/account/document/all-file/file/copy",
  COPY_FOLDER: "document/account/document/all-file/folder/copy",
  RENAME_FILE: "document/account/document/all-file/file/rename",
  RENAME_FOLDER: "document/account/document/all-file/folder/rename",
  DELETE_FOLDER: "document/account/document/all-file/folder/trash",
  DELETE_PERMANANT_FOLDER: "document/account/document/perma-delete/put",
  RECOVERY: "document/account/document/restore-file-folder/put",
  SEARCH_FILE: "document/account/document/all-file/search",
  STAR_FILE: "document/document/all-file/star",
  SEND_SHAREBLE_LINK: "pdfAndEmail/email-only/send",
  VIEW_ACTIVITY_FILE:
    "document/account/document/all-file/file/view-activity/get",
  VIEW_ACTIVITY_FOLDER:
    "document/account/document/all-file/folder/view-activity/get",
  DELETE_FIXED_DEPOSITE: "account/asset/fixed-income/fixed-deposit/delete",
  DELETE_RECURRING_DEPOSITE:
    "account/asset/fixed-income/recurring-deposit/delete",
  DELETE_BOND: "account/asset/fixed-income/bond/delete",
  DELETE_EPF: "account/asset/retirement/epf/delete",
  DELETE_NPS: "account/asset/retirement/nps/delete",
  DELETE_GRATUITY: "account/asset/retirement/gratuity/delete",
  DELETE_SUPERANNUATION: "account/asset/retirement/superannuation/delete",
  DELETE_EPS: "account/asset/retirement/eps/delete",
  DELETE_BANKACCOUNT: "account/asset/bank-account/delete",
  DELETE_CASHINHAND: "account/asset/cash-in-hand/delete",
  DELETE_GOLD: "account/asset/commodity/gold/delete",
  DELETE_OTHERS: "account/asset/commodity/other/delete",
  GLOBAL_LIABILITIES: "account/liability/global/get",
  UPLOAD_FILE: "document/account/document/all-file/file/put",
  FETCH_FILE_UPLOAD_DATA: "document/account/document/folderid/fetch",
  GET_FILE_UPLOAD_DATA_CLIENT: "document/account/document/people/image/get/all",
  FETCH_CLIENT_FILE_UPLOAD: "document/account/document/people/image/id/get",
  GET_COUNT_DOCS: "document/account/document/all-file/count/get",
  CLIENT_UPLOAD_FILE: "document/upload/pre-signed-url/get",
  SAVE_CLIENT_UPLOAD_FILE: "user/document/mapping/save",
  DELETE_CLIENT_UPLOAD_FILE: "user/document/mapping/delete",
  GET_CLIENT_PROOF: "document/download/pre-signed-url/get",
  GET_CLIENT_UPLOAD_FILE: "document/mapping/get",
  NEW_FOLDER: "document/account/document/all-file/folder/post",
  GET_ASSET_STOCK: "account/asset/stock/list/get",
  ADD_ASSET_STOCK: "account/asset/stock/add",
  GET_PORTFOLIO_LIST: "account/asset/stock/portfolio-list/get",
  // GET_PORTFOLIO_LIST: 'account/asset/portfolio/name/list/get',
  GET_PORTFOLIODATA_LIST: "account/asset/portfolio-summary/stock/list/get",
  GET_SCRIP_lIST: "account/asset/stock/scrip-name/get",
  GET_SCRIP_FILTER: "account/asset/stock/filtered/scrip-name/get",
  ADD_PORTFOLIO: "account/asset/stock/portfolio/add",
  DELETE_STOCK: "account/asset/stock/delete",
  DELETE_PORTFOLIO: "account/asset/stock/portfolio/delete",
  EDIT_STOCK_PORTFOLIO: "account/asset/stock/edit",
  ADD_SCRIP: "account/asset/stock/scrip-name/add",
  EDIT_SCRIP_HOLDING_TRANSACTION:
    "account/asset/stock/holding/transaction/edit",
  MUTUAL_FUND_GET: "mutual-fund/mutualfund/list/get",
  REPORT_WISE_CALCULATION: "mutual-fund/reportwise/calculation/get",
  MUTUAL_FUND_TRANSACTION_TYPE_LIST_POST:
    "mutual-fund/transaction/type/list/get",
  FOLIO_MASTER_DETAILS: "mutual-fund/folioMasterDetails/list/get",
  GET_BANK_DETAILS: "user/client/bank-detail/scheme-wise/get",
  SIP_DETAILS: "mutual-fund/sipDetails/list/get",
  UNREALIZED_TRANSACTION_GET: "mutual-fund/unrealized/transaction/list/get",
  CAPITAL_GAIN_GET: "mutual-fund/capital/gains/grandfathering/get",
  BANK_NAME_GET: "account/asset/client/family-member/bank-detail/list/get",
  MUTUAL_FUND_TRANSACTION_ADD: "mutual-fund/mutualFund/transaction/add",
  MUTUAL_FUND_TRANSACTION_EDIT: "mutual-fund/mutualFund/transaction/edit",
  MUTUAL_FUND_TRANSACTION_DELETE: "mutual-fund/mutualFund/transaction/delete",
  GET_TRANSACTION_TYPE: "mutual-fund/transaction/type/get",
  MUTUAL_FUND_ADD: "mutual-fund/mutualFund/add",
  MUTUAL_FUND_EDIT: "mutual-fund/mutualFund/edit",
  FAMILY_MEMBER_LIST_GET_BY_CLIENT_ID: "family/name/by/clientId/get",
  MUTUAL_FUND_SCHEME_NAME_LIST_GET: "mutual-fund/all/schemeName/list/get",
  MUTUAL_FUND_DELETE: "mutual-fund/mutualFund/scheme/folio/delete",
  GET_DATED_REPORT_WISE_CALCULATION:
    "mutual-fund/getDatedReportWiseCalculations/list/get",
  GET_NAV: "mutual-fund/avg/nav/get",
  UPDATE_CLIENT_PROFILE_PIC: "user/client/profile/pic/update",
  SAVE_FILTERS_GET: "mutual-fund/report/config/get",
  SAVE_FILTERS_ADD: "mutual-fund/report/config/add",
  GET_CLIENT_ALL_ASSET_COUNT: "account/asset/all/asset/count",
  GET_LOGIN_DATA_FROM_UUID: "user/login/with/uuid",
  GET_NOTES_ACTIVITY: "activity/note/list/get",
  ADD_NOTES_ACTIVITY: "activity/note/add",
  EDIT_NOTES_ACTIVITY: "activity/note/edit",
  DELETE_NOTES_ACTIVITY: "activity/note/multi/delete",
  DELETE_CAS_FILE: "mutual-fund/cas-file/data/delete",
  MF_FACT_SHEET_RISKOMETER: "mutual-fund/scheme/riskometer",
  MF_FACT_SHEET_ALLOCATION: "mutual-fund/scheme/company/percentage/allocation",
  MF_FACT_SHEET_NAV: "mutual-fund/scheme/historical/nav",
  MF_FACT_SHEET_COUNT: "mutual-fund/scheme/timeframe",
  MF_FACT_SHEET_SCHEME_DETAILS: "mutual-fund/scheme/details",
  MF_FACT_SHEET_INV_RET: "mutual-fund/scheme/invesment/returns",
  MF_FACT_SHEET_RATIO_GRAPH: "mutual-fund/scheme/relative/performance",
  GET_KYC_DETAILS_OF_CLIENT: "user/investor-kyc-remaining/count/get",
  HIDE_KYC_POPUP: "user/investor-kyc-remaining/hide",
  OTHER_FOLIO_DETAILS: "user/client/contact-number-and-email/scheme-wise/get",
  ELSS_TRANSACTIONS: "mutual-fund/elss/transaction/list/get",
  ////////////////////////////////plan////////////////////////////
  ADD_MANUAL_RISK_PROFILE: "plan/risk-assessment/manual/add",
  GET_RISK_PROFILE: "plan/risk-assessment/get",
  SUBMIT_RISK: "plan/risk-assessment/add",
  GET_GLOBAL_GOAL_DATA: "goal-planning/goal/global-data/get",
  ADD_RETIREMENT_GOAL: "",
  ADD_HOUSE_GOAL: "goal-planning/house/goal/add",
  ADD_CAR_GOAL: "goal-planning/car/goal/add",
  ADD_MARRIAGE_GOAL: "goal-planning/marriage/goal/add",
  ADD_SINGLE_YEAR_GOAL: "goal-planning/single-year/goal/add",
  ADD_MULTI_YEAR_GOAL: "goal-planning/multi-year/goal/add",
  ADD_EMERGENCY_GOAL: "goal-planning/emergency/goal/add",
  ADD_WEALTH_CREATION_GOAL: "goal-planning/wealth-creation/goal/add",
  ADD_BIGSPEND_GOAL: "goal-planning/big-spend/goal/add",
  ADD_OTHERS_GOAL: "goal-planning/others/goal/add",
  GET_TRANSACTION_EXPENSE: "account/expense/transaction/list/get",
  ADD_EXPENSE: "account/expense/transaction/add",
  EDIT_EXPENSE: "account/expense/transaction/edit",
  RISK_HISTORY: "plan/risk-assessment/history/get",
  RESULT_VIEW: "plan/risk-assessment-result/get",
  RECURING_EXPENSE_ADD: "account/expense/recurring/expense/add",
  RECURING_EXPENSE_GET: "account/expense/recurring/expense/list/get",
  RECURING_EXPENSE_EDIT: "account/expense/recurring/expense/edit",
  GET_BUDGETS: "account/expense/budget/list/get",
  ADD_BUDGET: "account/expense/budget/add",
  EDIT_BUDGET: "account/expense/budget/edit",
  OTHERCOMMITMENTS_ADD: "account/expense/othercommitments/add",
  OTHERCOMMITMENTS_EDIT: "account/expense/othercommitments/edit",
  OTHERCOMMITMENTS_GET: "account/expense/othercommitments/get",
  DELETE_TRANSACTION_EXPENSE: "account/expense/transaction/delete",
  DELETE_RECURRING_EXPENSE: "account/expense/recurring/expense/delete",
  DELETE_BUDGET: "account/expense/budget/delete",
  DELETE_RECURING_BUDGET: "account/expense/othercommitments/delete",
  BUDGET_GRAPH: "account/expense/graph/detail/of/budget/get",
  EXPENSE_GRAPH: "account/expense/graph/detail/of/expense/get",
  ADD_MANAGE_EXCLUSIVE: "activity/deployment/exclusion/edit",
  DELETE_DEPLOYMENT: "activity/deployment/archive-record/put",
  ADD_FILTER_SCHEME_LIST: "activity/deployment/add/filter/goal/scheme",
  GET_DEPLOYMENT_DETAILS: "activity/deployment/combined/deployment/detail/get",
  ADD_PURCHASE_SCHEME: "activity/deployment/purchase/scheme/post",
  GET_MUTUAL_FUND_SCHEME: "activity/deployment/scheme/get",
  GET_ALL_ASSETS: "goal-planning/other/asset/get",
  GET_ALL_GOALS: "goal-planning/goal/list/get",
  DELETE_GOAL: "goal-planning/goal/delete",
  CALCULATE_GOAL_EMI: "goal-planning/loan/calculate",
  SAVE_GOAL_EMI: "goal-planning/loan-info/save",
  CALCULATE_GOAL_DELAY: "goal-planning/cost-delay/calculate",
  SAVE_COST_DELAY_TO_GOAL: "goal-planning/cost-delay/save",
  EDIT_MULTI_YEAR_GOAL_PREFERENCE: "goal-planning/multi-year/edit",
  EDIT_SINGLE_YEAR_GOAL_PREFERENCE: "goal-planning/single-year/edit",
  SAVE_ASSET_ALLOCATION_PREFERENCE: "goal-planning/asset-allocation/update",
  // UPDATE_PREF_STATIC_ALLOCATION:'goal-planning/asset-allocation/update',
  // UPDATE_INFLAMATION_RETURNS:'goal-planning/asset-allocation/update',
  GET_MF_DATA: "goal-planning/goal/mf/list/get",
  SAVE_ASSET_TO_GOAL: "goal-planning/asset/allocate",
  SAVE_MILESTONE: "goal-planning/goal-milestone/save",
  EDIT_MILESTONE: "goal-planning/goal-milestone/edit",
  DELETE_MILESTONE: "goal-planning/milestone/remove",
  DELETE_LOAN: "goal-planning/goal-loan/delete",
  REMOVE_ALLOCATION: "goal-planning/asset/allocate",
  CALCULATE_TOTAL_VALUES: "account/asset/summary",
  GET_SUMMARY_LIST: "account/asset/summary/list",
  GET_ASSET_ALLOCATION_SUMMARY_LIST:
    "account/asset/asset-allocation/summary/get",

  GET_CASHFLOW_LIST: "cashflow/monthly/list/get",
  /////////////////////////Insurance plan/////////////////////////////
  GET_INSURANCE_LIST: "insurance/planning/list/get",
  GET_LIABILITIES: "account/liability/count/list",
  ADD_INSURANCE: "insurance/planning/insurance/add",
  GET_FAMILYMEMBER_DETAILS: "insurance/planning/family-member/info/get",
  GET_LIFE_NEED_ANALYSIS: "insurance/planning/life/insurance/need/analysis/get",
  ADD_LIFE_NEED_ANALYSIS_MAP:
    "insurance/planning/life/insurance/need/analysis/map/to/plan",
  REMOVE_LIFE_NEED_ANALYSIS_MAP: "insurance/planning/insurance/delete?",
  LIFE_ANALYSIS_ADD: "insurance/planning/life/insurance/need/analysis/save",
  GET_DETAILED_INSURANCE:
    "insurance/planning/life/insurance/need/analysis/mapped/to/plan/get",
  DELETE_INSURANCE_INPLANNING: "insurance/planning/insurance/delete",
  NEED_BASED_ANALYSIS:
    "insurance/planning/life/insurance/need/based/analysis/get",
  RECOMMENDATION_LIST_GET:
    "insurance/planning/life/insurance/recommendation/list/get?",
  INSURANCE_ADVICE_GET: "insurance/planning/life/insurance/advice/get",
  SUGGEST_POLICY_GET: "insurance/planning/life/insurance/suggest-policy/get",
  GENERAL_INSURANCE_ADVICE_GET: "insurance/planning/gen/insurance/advice/get?",
  GENERAL_INSURANCE_SUGGEST_POLICY:
    "insurance/planning/gen/insurance/suggest-policy/get?",
  UPDATE_CURRENT_POLICY_GI:
    "insurance/planning/general/insurance/need/analysis/current-policies/insert",
  GI_NEED_ANALYSIS_GET:
    "insurance/planning/general/insurance/need/analysis/get?",
  GENERAL_INSURANCE_ADD: "insurance/planning/general/insurance/planning/add",
  GENERAL_INSURANCE_REVIEW_GET:
    "insurance/planning/general/insurance/review/get",
  GENERAL_INSURANCE_CURRENT_POLICY_GET:
    "insurance/planning/general/insurance/current-policies/add/more/get",
  LIFE_INSURANCE_NEED_BASED_DETAILS:
    "insurance/planning/life/insurance/need/based/details/saved/get?",
  LIFE_INSURANCE_RECOMMENDATION_UPDATE:
    "insurance/planning/life/insurance/recommendation/status/update",
  GEN_INSURANCE_RECOMMENDATION_UPDATE:
    "insurance/planning/gen/insurance/recommendation/status/update",
  ADD_SUGGEST_NEW:
    "insurance/planning/life/insurance/need/analysis/suggest/new/add",
  ADD_GENERAL_INSURANCE_PLAN:
    "insurance/planning/general/insurance/suggest/policy/new/add",
  EDIT_GENERAL_INSURANCE_PLAN:
    "insurance/planning/general/insurance/suggest/policy/new/edit",
  GET_INSURANCE_PLANNING_PLAN_SUMMARY:
    "insurance/planning/plan/summary/insurance/get",
  GET_INSURANCE_PLAN_SUMMARY: "insurance/planning/summary/get",
  DELETE_SUGGEST_NEW: "account/insurance/general-insurance/delete",
  Edit_SUGGEST_NEW:
    "insurance/planning/life/insurance/need/analysis/suggest/new/edit",
  DELETE_SUGGESTED_POLICY:
    "insurance/planning/life/insurance/need/analysis/suggest/new/delete?",
  FREEZE_CAL: "goal-planning/goal/freeze",
  ADVISE_ON_HEALTH: "advice/insurance/life-insurance/add",
  ADVISE_ON_GENERAL_INSURANCE: "advice/insurance/gen-insurance/add",
  DELETE_INSURANCE_PLAN: "insurance/planning/unmap/general/insurance/plan",
  LIFE_INSURANCE_PLAN_ADD:
    "insurance/planning/life/insurance/plan/to/insurance/add",
  LIFE_INSURANCE_SUMMARY: "insurance/planning/summary2/get",
  ////////////////////////////// subscription////////////////////////////////////////////
  GET_REAL_ESTATE: "account/asset/real-estate/get",
  GET_OTHERS_ASSETS: "account/asset/other-asset/list/get",
  ADD_EPF_EPS: "account/asset/epf-eps/add",
  EDIT_EPF_EPS: "account/asset/epf-eps/edit",
  DELETE_EPF_EPS: "account/asset/epf-eps/delete",
  GET_EPF_EPS: "account/asset/epf-eps/get",
  GET_EPF: "account/asset/retirement/epf/list/get",
  ADD_EPF: "account/asset/retirement/epf/add",
  EDIT_EPF: "account/asset/retirement/epf/edit",
  GET_NPS: "account/asset/retirement/nps/list/get",
  ADD_NPS: "account/asset/retirement/nps/add",
  EDIT_NPS: "account/asset/retirement/nps/edit",
  GET_GRATUITY: "account/asset/retirement/gratuity/list/get",
  ADD_GRATUITY: "account/asset/retirement/gratuity/add",
  EDIT_GRATUITY: "account/asset/retirement/gratuity/edit",
  GET_SUPERANNUATION: "account/asset/retirement/superannuation/list/get",
  ADD_SUPERANNUATION: "account/asset/retirement/superannuation/add",
  EDIT_SUPERANNUATION: "account/asset/retirement/superannuation/edit",
  GET_EPS: "account/asset/retirement/eps/list/get",
  ADD_EPS: "account/asset/retirement/eps/add",
  EDIT_EPS: "account/asset/retirement/eps/edit",
  OTHER_PAYABLES: "account/liability/otherpayables/get",
  DELETE_PART_PAYMENT: "account/liability/part-payment/delete",
  DELETE_BORROWER: "account/liability/borrower/delete",

  ////////////////////////////// subscription////////////////////////////////////////////

  GET_SUBSCRIPTION_INVOICE: "subscription/invoice/get",
  // GET_SINGLE_INVOICE:'subscription/invoice/get',
  GET_PREFERENCE_BILLER_PROFILE: "subscription/billerprofile/get",
  GET_PREFERENCE_INVOICE_QUOTATIONS_SUBSCRIPTION:
    "subscription/setting/prefix/get",
  UPDATE_PREFERENCE_INVOICE_QUOTATIONS_SUBSCRIPTION:
    "subscription/setting/prefix/update",
  PREFERENCE_INVOICE_QUOTATIONS_SUBSCRIPTION_SAVE:
    "subscription/setting/prefix/save",
  SAVE_PREFERENCE_INVOICE_QUOTATIONS_SUBSCRIPTION:
    "subscription/setting/billerprofile/save",
  DASHBOARD_LETS_BEGIN_SUBSCRIPTION:
    "subscription/dashboard/record/payment/add",
  GET_CLIENT_SUBSCRIPTION_LIST: "subscription/client/get",
  GET_CLIENT_SUBSCRIPTION_QUOTATIONS_LIST: "subscription/client/quotation/get",
  GET_CLIENT_SUBSCRIPTION_INVOICES_LIST: "subscription/client/invoice/get",
  GET_CLIENT_SUBSCRIPTION_SETTING_PROFILE:
    "subscription/client/setting/profile/get",
  GET_SUBSCRIPTION_QUOTATIONS: "subscription/quotation/get",
  UPDATE_SUBSCRIPTION_QUOTATIONS: "subscription/quotation/edit",
  GET_SUBSCRIPTION_SUBSCRIPTION: "subscription/subscription/get",
  GET_SUBSCRIPTION_PLAN_SERVICE: "subscription/setting/plan-services/get",
  ADD_SETTING_PLAN_OVERVIEW: "subscription/plan/add",
  MAP_SERVICE_TO_PLAN: "subscription/setting/plan/mapservice",
  MAP_DOCUMENTS_TO_PLAN: "subscription/setting/plan/map/document",
  GET_PLAN_DOCUMENTS_DATA: "subscription/setting/plan-admindocument/get",
  GET_DOCUMENT_COUNT_SIGNED: "subscription/document/analytics/get",
  GET_CLIENT_WITH_SCRIPTION: "subscription/analytics/get",
  GET_INVOICE_TO_BE_REVIEWED: "subscription/invoice/review/get",
  GET_SUB_SUMMARY: "subscription/dashboard/summary/get",
  FILTER_SUBCRIPTION: "subscription/subscription/filtered/get",
  FILTER_INVOICES: "subscription/invoice/get",
  DASHBOARD_SUBSCRIPTION_LETS_BEGIN: "subscription/lets-begin/get",
  CANCEL_SUBSCRIPTION: "subscription/cancelled/subscription/update",
  DELETE_SUBSCRIPTION: "subscription/subscription/deleted/update",
  DELETE_CLIENT_PROFILE_FROM_SUBSCRIPTION_SETTING:
    "subscription/setting/clientbillerprofile/delete",
  SAVE_BILLER_PROFILE_SETTING: "subscription/setting/billerprofile/save",
  UPDATE_BILLER_PROFILE_SETTING: "subscription/setting/billerprofile/update",
  GET_SUBSCRIPTION_PLAN_SETTING: "subscription/setting/plan/get",
  GET_SUBSCRIPTION_SERVICE_SETTING: "subscription/setting/service/get",
  CREATE_SERVICE_SETTING: "subscription/service/create",
  EDIT_SERVICE_SETTING: "subscription/service/edit",
  DELETE_SUBSCRIPTION_PLAN: "subscription/plan/delete",
  GET_PLAN_MAPPED_TO_ADVISOR: "subscription/plan/mapped-to/advisor/get",
  GET_SUBSCRIPTION_DOCUMENTS_SETTING: "subscription/setting/document/get",
  GET_MAP_DOCUMENT_To_SERVICE: "subscription/mapped/document/service/get",
  ADD_CLIENT_BILLER_PROFILE: "subscription/client/biller/profile/add",
  ADD_SETTING_DOCUMENT: "subscription/document/add",
  GET_PLAN_OF_ADVISOR_CLIENT: "subscription/plans/of/advisor/get",
  GET_PLAN_INVOICE: "subscription/invoice/get",
  CREATE_SUBSCRIPTION: "subscription/client/subscription/add",
  EDIT_PAYEE_SETTINGS: "subscription/client/setting/profile/update",
  MAP_PLAN_TO_SERVICE_SETTING: "subscription/map/plan/service",
  UPDATE_INVOICE: "subscription/invoice/edit",
  CHANGE_PAYEE_SETTING:
    "subscription/client-biller/setting/subscription/update",
  CHANGE_SUBSCRIPTION_DETAILS: "subscription/subscription/edit",
  CHANGE_BILLER_SETTING: "subscription/change/biller-setting/subscription",
  EDIT_PLAN_SETTING: "subscription/plan/edit",
  GET_SERVICE_MODULE: "subscription/service/module/get",
  MAP_MODULE_TO_PLANS: "subscription/subscription/service/module-list/edit",
  GET_BILLER_PROFILE: "subscription/biller/profiles/get",
  GET_BANK_ADDRESS: "misc/ifsc",
  GET_SERVICES_LIST: "subscription/invoice-service/get",
  ADD_INVOICE: "subscription/invoice/manual/add",
  GET_PAYEE_PROFILE: "subscription/client-biller/profiles/get",
  SET_AS_PRIMARY: "subscription/client/setting/profile/setprimary",
  MAP_DOCUMENTS_TO_SERVICE: "subscription/map/plan/service/to/document/insert",
  MAP_SERVICE_TO_DOCUMENT: "subscription/setting/service/map/document",
  GET_DATA_FOR_CREATE_SERVICE: "subscription/service/create/details/get",
  EDIT_FEE_MODIFY_STRUCTURE: "subscription/client/subscription/fees/edit",
  GET_SUBSCRIPTION_START_DATA: "subscription/start/subscription/detail/get",
  GET_DOCUMENT_GET: "subscription/document/get",
  GET_ESIGNED_DOCUMENT_GET: "subscription/esigned/pdf/get",
  GET_DOCUMENT_UPDATE: "subscription/document/edit",
  GET_EMAIL_TEMPLATE: "subscription/email-template/list/get",
  EDIT_EMAIL_TEMPLATE: "subscription/email-template/edit",
  START_SUBSCRIPTION: "subscription/client/subscription/start",
  DELETE_SERVICE: "subscription/service/delete",
  GET_CLIENTLIST: "subscription/invoice/payees/get",
  SET_PRIMARY_BILLER: "subscription/setting/billerprofile/setprimary",
  GET_PAYMENT_RECEIVE: "subscription/invoice/payment/received/list/get",
  EDIT_PAYMENT_RECEIVE: "subscription/invoice/payment/received/edit",
  GET_TEMPLATE: "subscription/emailtemplate/get",
  GET_EMAIL_TEMPLATE_FILTER: "subscription/emailtemplate/get",
  VERIFIED_EMAIL_TEMPLATE_WISE: "setting/email/template/verified/email/get",
  // GET_DOCUMENT_MAPPED_PLAN: 'subscription/document/plan/map/get',
  GET_DOCUMENT_MAPPED_PLAN: "subscription/document/plan/mapping/get",
  GET_DOCUMENT_MAPPED_SERVICE: "subscription/document/service/map/get",
  GET_TOTAL_SALE_RECIVED: "subscription/dashboard/totalsales/feerecieved/get",
  DELETE_SUB_SETTING_BILLER_PROFILE:
    "subscription/setting/billerprofile/delete",
  GET_IMAGE_UPLOAD: "document/account/document/all-file/file/get",
  DELETE_SETTING_DOCUMENT: "subscription/setting/document/delete",
  DELETE_CLIENT_DOCUMENT: "subscription/multiple/subscription/document/delete",
  DELETE_QUOTATIONS: "subscription/multiple/quotation/document/delete",
  DELETE_INVOICE: "subscription/invoice/delete",
  DOCUMENT_ESIGN_REQUEST: "subscription/invoice/esignDocumentSend",
  GET_QUOTATION_SERVICE_DATA: "subscription/quotation/data/get",
  EMAIL_DOCUMENT: "pdfAndEmail/send/docId",
  GET_INVOICE_STATTUS: "subscription/invoice/status/edit",
  GET_BASE_64: "api/v1/test/base64/decode",
  GET_DOCUMENTS_PLACEHOLDERS: "subscription/document-placeholder/list/get",
  GET_QUOTATIONS_PLANS: "subscription/plans/subscribed/by/client/get",
  CREATE_QUOTATION: "subscription/quotation/add",
  CLIENTLIST_WITH_SUBSCRIPTION: "subscription/clients/with/subscriptions/get",
  GET_INVOICE_FEE_CALCULATIONS: "subscription/invoice/fee-calculation/get",
  SEND_INVOICE_EMAIL: "pdfAndEmail/send",

  //////////////////////////checklist///////////////////////////////////////////
  GET_CHECKLIST_TITLELIST: "rmdashboard/checklist/titleList/get",
  /////////steps//////////
  GET_STEPS: "rmdashboard/checklist/steps/get",

  // Plan Module////////////////////////

  GET_INCOME_LIST: "account/income/get",
  ADD_INCOME_LIST: "account/income/add",
  EDIT_INCOME_LIST: "account/income/edit",
  GET_GLOBAL_GROWTH_RATE: "account/income/growth/rate/global/get",
  DELETE_INCOME: "account/income/delete?",
  DELETE_INFLOW_BONUS: "account/income/bonusOrInflow/delete?",
  INCOME_OTHER_DELETE: "account/income/other/delete?",
  INCOME_RETIRAL_DELETE: "account/income/retiral/delete?",
  INCOME_ALLOWANCE_DELETE: "account/income/allowance/delete?",
  INCOME_PERQUISITES_DELETE: "account/income/perquisites/delete?",
  INCOME_REIMBURSEMENT_DELETE: "account/income/reimbursement/delete?",
  ASSTES_OF_EXPENSE: "account/expense/expense/of/asset/get",
  EXPENSE_ALL_GET: "account/expense/graph/detail/of/expense/get",
  FINPLAN_PDF_UPLOAD: "plan/financial-plan-html/upload",
  MEREGE_CALL: "plan/financial-plan-html/merge",
  GET_PDF_CALL: "plan/financial-plan/pdf/get",
  SAVE_PLAN_SECTION: "plan/financial-plan/save",
  GET_PLAN_SECTION: "plan/financial-plan/list/get",
  DELETE_FP_SECTION: "plan/financial-plan/delete",
  GET_TEMPLATES: "plan/financial-plan/advisor-template/list/get",
  GET_PREVIEW: "plan/financial-plan/pdf-url/get",
  /////////////////////////Activity///////////////////////////////////
  ADVICE_GET_ALL: "advice/advice/list/filter/get",
  ADVICE_ADD_FD: "advice/asset/fixed-income/suggest-new-fd/add",
  ADVICE_ADD_RD: "advice/asset/fixed-income/recurring-deposit/add",
  ADVICE_ADD_PPF: "advice/asset/small-saving-scheme/suggest-new-PPF/add",
  ADVICE_ADD_NSC: "advice/asset/saving-scheme/suggest-new-nsc/add",
  ADVICE_ADD_SSY: "advice/asset/small-saving-scheme/suggest-new-SSY/add",
  ADVICE_ADD_KVP: "advice/asset/saving-scheme/suggest-new-kvp/add",
  ADVICE_ADD_SCSS: "advice/asset/saving-scheme/scss/add",
  ADVICE_ADD_POSAVING: "advice/asset/saving-scheme/po-saving/add",
  ADVICE_ADD_PORD: "advice/asset/saving-scheme/suggest-new-pord/add",
  ADVICE_ADD_POTD: "advice/asset/saving-scheme/po-td/add",
  ADVICE_ADD_POMIS: "advice/asset/saving-scheme/suggest-new-pomis/add",
  ADVICE_ADD_REALESTATE: "advice/asset/suggest-new-real-estate/add",
  ADVICE_ADD_EPF: "advice/asset/retirement-account/suggest-new-epf/add",
  ADVICE_ADD_NPS: "advice/asset/retirement/suggest-new-nps/add",
  SCHEME_CHOICE: "account/asset/nps/global-data/get",
  SCHEME_FILTER_CHOICE: "account/asset/nps-master/list/get",
  ADVICE_ADD_GRATUITY:
    "advice/asset/retirement-account/suggest-new-gratuity/add",
  ADVICE_ADD_SUPERANNUATION:
    "advice/asset/retirement/suggest-new-superannuation/add",
  ADVICE_ADD_EPS: "advice/asset/retirement/eps/add",
  ADVICE_ADD_BANKACCOUNT:
    "advice/asset/cash-and-bank/suggest-new-bank-account/add",
  ADVICE_ADD_CASHINHAND:
    "advice/asset/cash-and-bank/suggest-new-cash-in-hand/add",
  ADVICE_ADD_GOLD: "advice/asset/commodity/suggest-new-gold/add",
  ADVICE_ADD_OTHERS: "advice/asset/commodity/suggest-new-other/add",
  GET_ADVICE_BY_CATEGORY: "advice/assetType/get",
  ADVICE_GET_DEPLOYMENTS: "activity/deployment/get",
  GENERATE_GROUP_ID: "advice/asset/consent/post",
  CONSENT_BYPASS_POST: "advice/asset/consent-bypass/post",
  GET_ASSET_CONSENT: "advice/advice/consent/get",
  UPDATE_ASSET_CONSENT: "advice/asset/update/consent",
  SENT_EMAIL_CONSENT: "advice/asset/update/consent/sent",
  GIVE_ADVICE_ON_GOLD: "advice/asset/gold/advice/post",
  GIVE_ADVICE_ON_PO_SAVING: "advice/asset/po-savings/advice/post",
  GIVE_ADVICE_ON_REAL_ESTATE: "advice/asset/real-estate/advice/post",
  GET_ALL_CATEGORY: "advice/advice/all-category/get",
  SUGGEST_NEW_INSURANCE:
    "advice/insurance/life-insurance/suggest-new-policy/add",
  SUGGEST_NEW_GENERAL_INSURANCE:
    "advice/insurance/gen-insurance/suggest-new-policy/add",
  DELETE_ADVICE: "advice/delete/id",
  EDIT_ADVICE: "advice/advice/edit",
  ////////////////////////////////////OnlineTransaction///////////////////////////////////////
  ADD_BSE_CREDENTIALS: "user/save",
  GET_BSE_CREDENTIALS: "user/view",
  UPDATE_INTERAKT: "interakt/update/interaktEnable/status",
  GET_ARNRIA_LIST: "setting/arn-ria/list/get",
  GET_RTA_LIST: "setting/arn-ria/rta/list/get",
  GET_AUTOUPLOAD_LIST: "rmdashboard/autoupload/reference/list/get",
  GET_AUTOUPLOAD_EMAIL_LIST: "rmdashboard/autoupload/email/list/get",
  AUTO_UPLOAD_REFRENCE_ADD: "rmdashboard/autoupload/references/update/add",

  INCENTIVE_RESELLER_UNPAID_LIST:
    "rmdashboard/reseller/incentive/total/unpaid/bills/over-all/list/get",
  INCENTIVE_RESELLER_PAYMENT_LIST:
    "rmdashboard/re-seller/payment/incentive/get",
  INCENTIVE_RESELLER_INVOICE_INCENTIVE_GET:
    "rmdashboard/re-seller/invoice/incentive/get",
  INCENTIVE_RESELLER_ADVISOR_INVOICE_GET:
    "rmdashboard/re-seller/advisor/invoice/incentive/get",
  INCENTIVE_RESELLER_TOTAL_COUNT_GET: "rmdashboard/re-seller/total/count/get",
  INCENTIVE_MYIFAS_LIST: "rmdashboard/myifas/dashboard/details/new/Filter/get",
  BILLING_INVOICE_REASON: "user/advisor/credit-points/desc/get",
  BILLING_INVOICE_DELETE: "user/advisor/advisor/invoice/delete",
  ADD_PAYEE_SUBSCRIPTION: "user/advisor/billing-detail/add",
  EDIT_PAYEE_SUBSCRIPTION: "user/advisor/billing-detail/edit",
  SEARCH_SUPPLY: "user/advisor/zoho/place-of-supply/get",
  PRICING_ZOHO_ADD: "user/advisor/zoho-billing-detail/add",

  GET_PRESIGN_HTML_TO_PDF: "document/presign/url/gen",
  PULL_REQUEST: "document/s3/file/present",
  QUEUE_REQUEST: "document/offer/html/to/pdf/queue",
  GET_IINUCC_PENDING: "user/register/all/get",
  ADD_SUB_BROKER: "user/sub-broker/save",
  DELETE_BROKER: "user/delete",
  DELETE_SUB_BROKER: "user/sub-broker/delete",
  GET_BSE_SUB_BROKER_CREDENTIALS: "user/sub-broker/view/details",
  GET_NEW_SCHEMES: "mutual-fund/search",
  GET_EXISTING_SCHEMES: "mutual-fund/existing/search",
  GET_SCHEME_DETAILS: "mutual-fund/product-limit/get",
  GET_FAMILY_MEMBER: "family/name/get",
  GET_DEFAULT_DETAILS: "user/family-member/transaction-setting/default",
  PURCHASE: "bse/order/bse/order/create",
  GET_AMCWISE_FOLIO: "mutual-fund/folios/amc-wise/get",
  GET_SCHEMEWISE_FOLIO: "mutual-fund/folios/scheme-wise/get",
  GET_MANDATE_DETAILS: "mandate/view",
  GET_UNMAPPED_CLIENTS: "user/client/unmapped/view",
  GET_MAPPED_CLIENTS: "user/client/mapped/view",
  GET_MAPPED_CLIENTS_FILTER: "user/client/mapped/filter/client-wise/view",
  UPDATE_ALL_NSE_CLIENTS: "nse/iin/all/update",
  AUTO_REMAP_CLIENT: "user/clients/remap/auto",
  GET_KYC_TRANASCTION_MATRIX: "user/advisor/kyc-metrics/get",

  MAP_UNMAP_CLIENT: "user/clients/map/manual",
  UNMAP_MAP_CLIENT: "user/clients/unmap",
  BSE_UCC_FILE_UPLOAD: "user/bse/client/file-upload",
  MAP_UNMAP_FOLIO: "mutual-fund/folio/map/manual",
  UNMAP_MAP_FOLIO: "mutual-fund/folio/unmap",
  GET_FREQUENCY: "bse/scheme/sip/view",
  GET_FREQUENCY_STP: "bse/scheme/stp/view",
  SIP_BSE: "bse/order/create",
  BSE_TRANSACTION: "bse/order/create",
  UPLOAD_FILE_IMAGE: "user/register/image/upload",
  MANDATE_UPLOAD: "mandate/image/upload",
  BANK_DETAILS_NSE: "nse/iin/bank-detail/get",
  GETIIN_DETAILS: "nse/iin/detail/get",
  GET_FOLIO_MAPPED: "mutual-fund/folios/mapped/get",
  GET_FOLIO_UNMAPPED: "mutual-fund/folios/unmapped/get",
  GET_CLIENT_CODE: "user/family-member/client-code",
  GET_EMPANELLED_AMC: "mutual-fund/hidden-amc/amc-wise/get",
  ADD_HIDDEN_AMC: "mutual-fund/hidden-amc/add",
  DELETE_HIDDEN_AMC: "mutual-fund/hidden-amc/delete",
  SEARCH_SCHEME: "report/transaction/list/get",
  GET_TRANSACTION_DETAILS: "report/transaction/status/get",
  GET_OVERVIEW_MANDATE: "mandate/summary",
  GET_IIN_UCC_OVERVIEW: "report/client-code/count/get",
  GET_MANDATE_LIST: "report/ach-mandate/get",
  GET_REGISTRATION_UCC_IIN: "user/register/detail/get",
  MAPPED_EXSTING_USER: "nse/iin/mapping/update",
  UPLOAD_NEW_FATACA: "user/register/fatca/change/upload",
  // GET_CLIENT_FM_LIST,: 'user/client/family/filter/get',
  CREATE_IIN_UCC: "user/register/create",
  GET_TOKEN: "user/bse/upload/password",
  BANK_MANDTAE: "nse/iin/bank/detail/get",
  TAX_MASTER: "user/tax-master/get",
  COUNTRY_MASTER: "user/register/country-code/all/get",
  INVESTER_KYC_LIST_GET: "user/investor-with-kyc/list/get",
  INVESTOR_FORM_UPLOAD_DETAIL: "user/register/upload/all/get",
  INVESTOR_STATUS_CHECK: "user/register/status/check/update",

  ADD_MANDATE: "mandate/add",
  // SIP_BSE:'bse/order/create',

  // cashflow
  CASHFLOW_ADD_INCOME: "cashflow/income/add",
  CASHFLOW_GET_INCOME: "cashflow/income/get",
  CASHFLOW_DELETE_INCOME: "cashflow/income/delete",
  CASHFLOW_EDIT_INCOME: "cashflow/income/edit",
  CASHFLOW_GET_MONTHLY_DISTRIBUTION_INCOME:
    "cashflow/income/monthly-distribution/get",
  CASHFLOW_EDIT_MONTHLY_INCOME: "cashflow/income/monthly/edit",
  CASHFLOW_GET_YEARLY_EXPENSE: "cashflow/expense/list/get",
  CASHFLOW_GET_MONTHLY_EXPENSE: "cashflow/expense/monthly/list/get",
  CASHFLOW_ADD_EXPENSES: "cashflow/expense/add",
  CASHFLOW_EDIT_EXPENSES: "cashflow/expense/edit",
  CASHFLOW_DELETE_EXPENSES: "cashflow/expense/delete",
  CASHFLOW_EDIT_MONTHLY_EXPENSE_DISTRIBUTION:
    "cashflow/expense/monthly-distribution/edit",
  CASHFLOW_GET_YEARLY_LIABILITIES: "cashflow/liability/list/get",
  CASHFLOW_GET_MONTHLY_LIABILITIES: "cashflow/liability/monthly/list/get",
  CASHFLOW_ADD_LIABILITIES: "cashflow/liability/add",
  CASHFLOW_EDIT_LIABILITIES: "cashflow/liability/edit",
  CASHFLOW_DELETE_LIABILITIES: "cashflow/liability/delete",

  // backoffice

  BACKOFFICE_GET_ALL_SCHEMES_NJ: "backoffice/get/allshemes/nj",
  BACKOFFICE_GET_ALL_SCHEMES_PRUDENT: "backoffice/get/allshemes/prudent",
  BACKOFFICE_GET_UNMAPPED_SCHEMES_NJ_PRUDENT:
    "rmdashboard/get/unmapped/njprudent/schemes",
  BACKOFFICE_GET_FILTERED_SCHEMES: "backoffice/get/filtered/shemes",
  BACKOFFICE_ADV_GET_BROKER_LIST: "setting/arn-ria/list/get",
  BACKOFFICE_GET_RT_LIST: "backoffice/rt/list/get",
  BACKOFFICE_GET_AUM_RECON_HISTORY_LIST: "backoffice/aum/recon/history/get",
  BACKOFFICE_GET_AUM_ORDER_LIST: "backoffice/aum/file/order/list/get",
  BACKOFFICE_GET_AUM_RECON_LIST: "backoffice/aum/reconcillation/list/get",
  BACKOFFICE_PUT_AUM_TRANSACTION_KEEP_OR_REMOVE:
    "backoffice/aum/transaction/keep/remove",
  BACKOFFICE_PUT_AUM_RECON_ADD: "backoffice/aum/recon/add",
  BACKOFFICE_PUT_FILE_ORDER_RETRY: "backoffice/aum/file/order/retry",
  BACKOFFICE_DELETE_AUM_TRANSACTION_SINGLE_MULTIPLE:
    "backoffice/aum/transaction/multiple/delete",
  BACKOFFICE_DELETE_AND_REORDER: "backoffice/aum/delete-reorder",
  BACKOFFICE_PUT_FREEZE_FOLIO_DATA: "backoffice/aum/freeze/folio",
  BACKOFFICE_PUT_UNFREEZE_FOLIO_DATA: "backoffice/mutual-fund/unfreeze",
  BACKOFFICE_GET_DUPLICATE_FOLIO_DATA:
    "backoffice/duplicate/transaction/list/get",
  BACKOFFICE_FOLIOWISE_LIST_GET:
    "backoffice/aum/transaction/foliowise/list/get",
  BACKOFFICE_PUT_UNMAP_FOLIO: "backoffice/unmap/folio",
  BACKOFFICE_UNMAPPED_FOLIO: "mutual-fund/unmap/investor/details",
  BACKOFFICE_GET_FOLIO_MASTER_DETAIL: "backoffice/mutual-fund/folio-master/get",
  BACKOFFICE_GET_DUPLICATE_DATA_LIST: "backoffice/duplicate-data/get",
  BACKOFFICE_POST_UNMATCHED_FOLIOS_ADD:
    "backoffice/aum/recon/unmatched/folios/add",
  BACKOFFICE_GET_AUM_REPORT_LIST: "backoffice/aum/reconciliation/report/get",
  BACKOFFICE_GET_FOLIO_BASED_SEARCH_LIST:
    "backoffice/folio/based/on/search/list/get",
  BACKOFFICE_RM_RECALCULATE_BALANCE_UNITS:
    "backoffice/recalculate/balance/unit",
  BACKOFFICE_MERGE_SUNDARAM_SCHEME_CODE: "backoffice/merge/schemes/sundaram",
  PUT_MERGE_ALL_SCHEMES: "backoffice/merge/all/schemes",
  BACKOFFICE_MERGE_SUNDARAM_SELECTED_SCHEME_CODE:
    "backoffice/merge/schemes/sundaram/select/focus",
  BACKOFFICE_MERGE_SCHEME_CODE: "backoffice/merge/schemes",
  BACKOFFICE_MERGE_SCHEME_CODE_BULK: "backoffice/merge/schemes/bulk/level",
  // BACKOFFICE_GET_GROUP_HEAD_NAME_LIST: 'backoffice/foliowise/groupHead/list/get',
  // BACKOFFICE_GET_INVESTOR_NAME_LIST: 'backoffice/foliowise/applicaName/list/get',
  BACKOFFICE_PUT_DELETE_UNFREEZE_TRANSACTION:
    "backoffice/delete/unfreeze/transaction",
  BACKOFFICE_FOLIO_COUNTS: "backoffice/folioCount/get",
  BACKOFFICE_UPLOAD_SIP: "backoffice/upload/sip",
  BACKOFFICE_FILE_UPLOAD_TYPE: "backoffice/file-upload/types/get",
  BACKOFFICE_FILTER: "backoffice/file-upload/filter/get",
  BACKOFFICE_FILE_TO_UPLOAD: "backoffice/file-upload/url/get",
  UPLOAD_NJ_FILE: "backoffice/upload/NJ",
  UPLOAD_PRUDENT_FILE: "backoffice/upload/Prudent",
  UPLOAD_STOCK: "account/asset/upload/excel",
  TRANSACTION_UPLOAD: "account/asset/stock-transaction/bulk/upload",
  HOLDING_UPLOAD: "account/asset/stock-holding/bulk/upload",
  BACKOFFICE_TRANSACTIONS:
    "backoffice/file-upload/uploaded/transaction/list/get",
  BACKOFFICE_SIP_STP: "backoffice/file-upload/uploaded/sip/list/get",
  BACKOFFICE_FOLIO: "backoffice/file-upload/uploaded/folio-master/list/get",
  BACKOFFICE_SUCCESS_FILE_UPLOAD: "backoffice/file-upload/success",
  GET_BACKOFFICE_ADVISOR_SEARCH_NAME: "backoffice/advisor/search/name",
  BACKOFFICE_FILEUPLOAD_AUM_LIST_GET:
    "backoffice/file-upload/uploaded/aum/list/get",
  BACKOFFICE_AMC_LIST_GET: "backoffice/amc-list/get",
  BACKOFFICE_AMC_TICOP_TRANSCATION_GET: "backoffice/aum/ticop/transactions/get",

  GET_REMINDERS: "rm/reminder/get",
  UPDATE_REMINDER: "rm/reminder/edit",
  ADD_EXPIRY_REMINDER: "rm/reminder/add",
  DELETE_REMINDER: "rm/reminder/delete",
  GET_DAILY_SERVICES_STATUS_REPORT:
    "rmdashboard/dashboard/daily/services/status/get",
  GET_DAILY_FILES: "rmdashboard/dashboard/daily-file/get",
  FILTER_HISTORICAL_REPORT: "rmdashboard/dashboard/historic/files/filter/get",
  GET_IFA_MATRIC_DATA: "rmdashboard/dashboard/ifas/metric/get",
  GET_MY_IFA_DETAILS: "rmdashboard/myifas/dashboard/details/get",
  GET_NEW_MY_IFA_DETAILS: "rmdashboard/myifas/dashboard/details/new/get",
  GET_ONBOARDING_DETAILS: "rmdashboard/myifas/onboarding/details/get",
  GET_MY_IFA_FILTER: "rmdashboard/myifas/dashboard/details/get/filter",
  GET_MY_IFA_ONBOARDING: "rmdashboard/ifa-onboarding/list/get",
  SEARCH_MY_IFA_VALUES: "rmdashboard/myifas/dashboard/details/get/filter",
  GET_ONBOARDING_TASK_GLOBAL: "rmdashboard/ifa/onboarding/task/global/get",
  GET_MASTER_IFA_TASK_LIST: "rmdashboard/onboarding/master/list/get",
  POST_HISTORICAL_FILE_ORDER: "fileorder/historical/order",
  POST_HISTORICAL_FILE_ORDER2: "fileorder/historical/order/ext-col",
  GET_FILETYPE: "fileorder/automated/file/type/filter/list/get",
  GET_AUTOMATED_DATA: "fileorder/automated/bulk/list/get",
  GET_AUTOMATED_DETAIL_DATA: "fileorder/automated/bulk/order/list/get",
  GET_AUTOMATED_FILTER_LIST_ADVISOR_DATA:
    "fileorder/automated/advisor/search/filter/list/get",
  GET_AUTOMATED_RETRY: "fileorder/automatic/list/retry",
  GET_SELECTCLUB_FILEORDER: "fileorder/select/club/historical/list/get",
  RETRY_TRXN_FILEORDER: "backoffice/aum/recon/trxn/file/order/retry",

  GET_FILE_TYPE_ORDER: "fileorder/file-type/list/get",
  GET_IFA_ONBOARDING_OVERVIEW: "rmdashboard/ifa/onboard/overview/get",
  UPDATE_IFA_ONBOARDING_OVERVIEW: "rmdashboard/ifa/onboard/overview/update",
  GET_IFA_ONBOARDING_ACTIVITY:
    "rmdashboard/dashboard/ifa-onboard/advisor-id/get",
  EDIT_ACTIVITY: "rmdashboard/dashboard/ifa-onboard/advisor-id/task/put",
  ACTIVITY_ADD_COMMENT: "rmdashboard/dashboard/ifa-onboard/activity/chat/post",
  ACTIVITY_UPDATE_COMMENT:
    "rmdashboard/dashboard/ifa-onboard/activity/chat/edit",
  ACTIVITY_DELETECOMMENT:
    "rmdashboard/dashboard/ifa-onboard/activity/chat/delete",
  GET_SCHEMES_DETAILS: "rmdashboard/get/scheme/details",
  MF_LIST_UNFREEZE: "mutual-fund/mf-list/unfreeze",
  EDIT_SIP_AMOUNT: "backoffice/sip-cleanup/sip-amount/edit",
  RESEND_REPORT_NOW: "mutual-fund/report/bulk-order/resend",
  GET_FILE_UPLOAD: "backoffice/excel/file-upload/url/get",
  UPLOAD_TRANSACTION_FILE: "backoffice/excel/file-upload/success",
  UPLOAD_IFAST_FILE: "rmdashboard/ifast/file/upload",
  GENERATE_IFAST_PDF: "rmdashboard/ifast/pdf/Generate",
  GET_IFAST_ZIPLINK: "rmdashboard/ifast/get/zipLink",
  GET_CREDIT_HISTORY: "billing/credit-wallet/transaction/list/get",
  GET_WALLET_DETAILS: "billing/wallet-detail/get",
  /********************************* TASKS Section ****************************************/

  ACTIVITY_GET_ALL_TASK_LIST: "activity/task/list/get",
  ACTIVITY_GET_ALL_TASK_STATUS_LIST: "activity/task/global-data/get",
  ACTIVITY_TASK_GET_TASK_TEMPLATE_LIST: "activity/task/template-list/get",
  ACTIVITY_TASK_GET_INDIVIDUAL_TASK_TEMPLATE: "activity/task/template/get",
  ACTIVITY_TASK_SUBTASK_ADD: "activity/task/sub-task/add",
  ACTIVITY_TASK_ADD_COLLABORATOR: "activity/task/collaborator/add",
  ACTIVITY_ADD_TASK: "activity/task/add",
  ACTIVITY_ADD_ATTACHMENT_UPLOAD_URL_GET:
    "activity/task/attachment-upload-url/get",
  ACTIVITY_ADD_TASK_SUBTASK_ATTACHMENT: "activity/task/sub-task/attachment/add",
  ACTIVITY_DELETE_TASK: "activity/task/delete",
  ACTIVITY_DELETE_ATTACHMENT_TASK_SUBTASK: "activity/task/attachment/delete",
  ACTIVITY_DELETE_COMMENT_TASK_SUBTASK: "activity/task/comment/delete",
  ACTIVITY_DELETE_COLLABORATOR_FROM_TASK: "/activity/task/collaborator/delete",
  ACTIVITY_DELETE_SUBTASK_FROM_TASK: "activity/task/sub-task/delete",
  ACTIVITY_MARK_TASK_OR_SUBTASK_DONE: "activity/task/sub-task/status/update",
  ACTIVITY_GET_ATTACHMENT_DOWNLOAD_OF_TASK_SUBTASK:
    "activity/task/attachment-download-url/get",
  ACTIVITY_TASK_EDIT: "activity/task/edit",
  ACTIVITY_SUBTASK_EDIT: "activity/task/sub-task/edit",
  ACTIVITY_ADD_COMMENT_TASK_SUBTASK: "activity/task/sub-task/comment/add",
  ACTIVITY_EDIT_COMMENT_TASK_SUBTASK: "activity/task/comment/edit",
  ACTIVITY_GET_ATTACHMENT_PREVIEW_LIST: "activity/task/attachment/list/get",
  ACTIVITY_POST_TASK_COMMENT_REPLIES: "activity/task/sub-task/comment/add",

  GET_STAGE_COMMENT: "rmdashboard/dashboard/ifa-onboard/stages/chat/get",
  EDIT_STAGE_COMMENT: "rmdashboard/dashboard/ifa-onboard/stages/chat/edit",
  EDIT_ONBOARDING_COMMENT_BY_ID_: "rmdashboard/ifa/onboarding/comment/edit",
  DELETE_STAGE_COMMENT: "rmdashboard/dashboard/ifa-onboard/stages/chat/delete",
  ADD_STAGE_COMMENT: "rmdashboard/dashboard/ifa-onboard/stages/chat/post",
  GET_BULK_FILE_ORDER_LIST: "fileorder/bulk/list/get",
  GET_BULK_FILE_ORDER_UPPER_LIST: "fileorder/bulk/order/list/get",
  UNMAPPED_ADVISOR_LIST: "rmdashboard/dashboard/admin/unmapped-ifas/get",
  MAP_ADVISOR_TO_RM: "rmdashboard/dashboard/admin/map-ifa-to-rm/post",
  CHANGE_MAP_TO_RM: "rmdashboard/advisor-to-rm/update",
  UNMAP_ADVISOR_TO_RM: "rmdashboard/rm/advisor/unmap",
  IGNORE_ADVISOR_TO_RM: "rmdashboard/advisor/ignore/update",
  GET_RM_LIST: "rmdashboard/dashboard/admin/rm/list/get",
  GET_RM_NAME_LIST: "rmdashboard/rm/name/list/get",
  GET_ROLES_LIST: "rmdashboard/support/role/master/list/get",
  ADD_RM: "rmdashboard/dashboard/admin/rm/add",
  EDIT_RM: "rmdashboard/dashboard/admin/rm/edit",
  DISABLE_RM: "rmdashboard/dashboard/admin/rm/disable",
  GET_MY_IFA_REC_SUMMARY: "rmdashboard/myifas/recon-summary/get",
  GET_FILE_ORDER_HISTORICAL_LIST_DATA: "fileorder/historical/advisor/list/get",
  GET_FILE_ORDER_REFRESH_LIST_DATA: "fileorder/historical/ext-col/list/get",
  GET_FILE_ORDER_UPPER_LIST_DATA: "fileorder/historical/list/get",
  GET_FILE_ORDER_REFRESH_UPPER_LIST_DATA: "fileorder/historical/ext/list/get",
  POST_FILE_ORDER_BULK_DATA: "fileorder/bulk/order",
  PUT_FILE_ORDER_RETRY: "fileorder/list/retry",
  GET_TICKET: "rmdashboard/tickets/get",
  GET_REPORT_FILTER_DATA: "rmdashboard/myifas/dashboard/details/get/filter",
  GET_COMMENT_COUNT_RM_ADMIN:
    "rmdashboard/dashboard/ifa-onboard/task-level-comment/count",
  GET_FILE_ORDER_ARN_RIA_LIST: "fileorder/arn-ria/list/get",
  REFRESH_FILE_ORDER_HISTORICAL_PER_ROW:
    "fileorder/historical/advisor/order/refresh",
  REFRESH_FILE_ORDER_BULK_PER_ROW: "fileorder/bulk/order/refresh",
  REFRESH_FILE_ORDER_PER_ROW: "fileorder/historical/order/ext-col",
  REFRESH_FILE_ORDER_AUTOMATED_PER_ROW:
    "fileorder/automated/bulk/order/refresh",
  REFRESH_FILE_ORDER_UPPER: "fileorder/refresh",
  DEACTIVATE_ACCOUNT: "rmdashboard/activate-deactivate/advisor",
  CANCEL_ACCOUNT: "user/advisor/subscription/cancel",
  REFRESH_MF_LIST: "mutual-fund/mutualfund/list/refresh",
  CONVERT_TO_PAID_DATE: "rmdashboard/advisor/paid-upto/update",
  GET_ALL_RESTORE_TRANSACTION:
    "backoffice/folio-query/mf-transaction/deleted-list/get",
  RESTORE_MF_TRANSACTION: "backoffice/folio-query/mf-transaction/restore",
  GET_PREVIOUS_COMMENTS: "rm/reminder/comment/previous/get",
  GET_COMMENTS: "rm/reminder/comment/get",
  POST_COMMENT_RECON: "rm/reminder/comment/add",
  EDITCOMMENT: "rm/reminder/comment/edit",
  DELETECOMMENT: "rm/reminder/comment/delete",
  RM_ADVISORS: "rmdashboard/dashboard/rm/ifas/list/get",
  GET_INCENTIVE_BILL_PAID_LIST: "rmdashboard/incentive/bill-paid/list/get",
  GET_INCENTIVE_ALL_COUNT: "rmdashboard/incentive/all/counts/get",
  GET_INCENTIVE_BILL_PAID_COUNT: "rmdashboard/incentive/bill-paid/count/get",
  GET_INCENTIVE_UPAID_BILLS_THIS_MONTH_LIST:
    "rmdashboard/incentive/total/unpaid/bills/this-month/list/get",
  GET_INCENTIVE_BILL_PAYMENT_RATIO_LIST:
    "rmdashboard/incentive/bill/payment/ratio/list/get",
  GET_INCENTIVE_TOTAL_UNPAID_BILLS_OVERALL_LIST:
    "rmdashboard/incentive/total/unpaid/bills/over-all/list/get",
  GET_INCENTIVE_UPFRONT_EARNED_LIST:
    "rmdashboard/incentive/upfront/earned/list/get",
  GET_INCENTIVE_OVERVIEW_LIST: "rmdashboard/incentive/overview/list/get",
  GET_HIERARCHY_RM_ROLE_ACCESS_RIGHT_MAPPING:
    "rmdashboard/hierarchy/rm/role/access/right/mapping/get",
  ADD_RM_HIERARCY: "rmdashboard/hierarchy/add/new/rm/post",
  GET_RM_NAME_HIERARCY_LIST: "rmdashboard/rm/name/hierarchy/list/get",
  GET_NEW_INCENTIVE_DATA: "rmdashboard/get/incentive/list",
  GET_RM_NAME_MASTER_LIST: "rmdashboard/myifas/filter/master/get",
  GET_UPCOMING_FILTER_LIST: "rmdashboard/exotel/schedule/call/assign",
  GET_COMMENT_ONBOARDING: "rmdashboard/ifa/onboarding/comment/get",
  POST_COMMENT_ONBOARDING: "rmdashboard/ifa/onboarding/comment/add",
  POST_COMMENT_REMARK: "rmdashboard/add/remark",
  GET_COMMENT_REMARK: "rmdashboard/remark",
  EDIT_COMMENT_REMARK: "rmdashboard/update/remark",
  DELETE_COMMENT_REMARK: "rmdashboard/delete/remark",

  GET_CAMPAIGN_LIST: "rmdashboard/internal/campaign/master/list/get",
  UPDATE_CAMPIGN_LIST: "rmdashboard/internal/campaign/master/advisor/update",

  ///org setting ////
  GET_PORTFOLIO: "setting/preferences/portfolio/get",
  GET_PLANS: "setting/preferences/plan/get",
  PROTFOLIO_UPDATE: "setting/preferences/portfolio/update",
  PLAN_SECTION_UPDATE: "setting/preferences/plan/update",
  DOMAIN_GET: "setting/preferences/domain/get",
  UPDATE_DOMAIN: "setting/profile/organisation/url/update",
  EDIT_ORG_PROFILE_LOGO: "setting/profile/organisation/logo/update",
  EDIT_ORG_PROFILE_REPORT_LOGO:
    "setting/profile/organisation/report/logo/update",
  RESET_ORG_PROFILE_LOGO: "setting/organisation/logo/delete",
  RESET_ORG_REPORT_LOGO: "setting/organisation/report-logo/delete",
  GET_EMAIL_VERIFICATION: "setting/preference/email/get",
  GET_EMAIL_VERIFICATION_REPORT: "mutual-fund/report/email-list/get",
  SAVE_EMAIL_ID_REPORT: "mutual-fund/report/from-email/save",
  GET_EMAIL_TEMPLATES: "setting/preference/email/template/get",
  GET_EMAIL_LIST: "setting/preference/verified/email-list/get",
  EDIT_PREF_EMAIL_TEMPLATE: "setting/preference/email/template/update",
  DELETE_PREF_EMAIL_TEMPLATE: "setting/preference/email/delete",
  DELETE_EMAIL_VERIFY: "setting/preference/email/delete",
  ADD_EMAIL_VERIFY: "setting/preferences/email/post",
  GET_ASSET_ALLOCATION: "goal-planning/static-allocation/get",
  GET_RETURNS: "plan/config/return-inflation/get",
  GET_KEY_PARAMETERS: "goal-planning/key-parameters/get",
  UPLOAD_PLAN_GALLERY: "goal-planning/goal-gallery/add",
  UPLAOD_INDIVIDUAL_GOAL_IMG: "goal-planning/image-url/update",
  UPLOAD_KEY_PARAMETER: "goal-planning/advisor-plan-configuration/add",
  UPDATE_ASSET_ALLOCATION: "goal-planning/static-allocation/put",
  GET_TASK_TEMPLATE: "setting/task/template/list/get",
  ADD_SUB_TASKTEMPLATE: "setting/task/sub-task/add",
  TASK_GLOBAL: "setting/task/template/global/data",
  ADD_TAK_TEMPLATE: "setting/task/template/add",
  EDIT_TASK_TEMPLATE: "setting/task/template/edit",
  DELETE_TASK_TEMPLATE: "setting/task/template/delete",
  DELETE_SUBTASK_TEMPLATE: "setting/task/sub-task/delete",
  OWNER_SUBTASK_UPDATE: "setting/task/template/owner/update",
  OWNER_TASK_UPDATE: "setting/task/sub-task/owner/update",
  GET_TEAM_MEMBER: "setting/users/team-members/get",
  GET_BACKOFFICE_TEAM_MEMBER_LIST: "backoffice/team-members/get",
  GET_SUB_ADVISOR_LIST: "mutual-fund/sub/advisor/list/get",
  UPDATE_ACCESS_CONTROL: "setting/users-roles/access-rights/update",
  RESET_GALLARY: "goal-planning/goal-gallery/reset",
  UPDATE_RETURNS_AND_INFLATIONS: "plan/config/return-inflation/put",
  GET_APPEARANCE_SETTING: "setting/preferences/appearance/get",
  UPDATE_APPEARANCE_SETTING: "setting/preferences/appearance/update",
  GET_USER_ROLES: "setting/users-roles/role/get",
  GET_CLIENT_ROLES: "setting/users-roles/client-role/get",
  ORDER_SOA_MUTUAL_FUND: "mutual-fund/SOA/fetch",
  BULK_EMAIL_PASSWORD: "pdfAndEmail/new-user-creds/mail/send",
  CLIENT_SEND_EMAIL: "setting/bulk/welcome-email/send",
  BULK_SMS: "setting/bulk/welcome-sms/send",
  GET_BULK_EMAIL_LOG: "setting/bulk/welcome-sms/log-list/get",
  ENABLE_DISABLE_TEMPLATE: "setting/disable-or-enable/email-template",
  DOMAIN_LIST: "account/asset/domain-provider/detail/get",
  REMOVE_EMAIL: "setting/preference/email/category/from/email/remove",
  CHECK_WHITE_LABEL_AND_UPDATE: "setting/white-label/check",
  GET_BULK_EMAIL_SUBJECT_TEMPLATE: "setting/preference-email/template/get",
  // gmail
  ACCESS_TOKEN_SAVE: "user/access-token/gmail/save",
  GET_PROFILE: "gmail/users/getProfile",
  GET_RIGHT_SIDE_NAV: "user/label/list/get",
  DELETE_MESSAGES: "gmail/messages/delete",
  MODIFY_MESSAGES: "gmail/messages/modify",
  MOVE_MESSAGES_TO_TRASH: "gmail/messages/thrash",
  MOVE_MESSAGES_FROM_TRASH: "gmail/messages/untrash",
  DELETE_MULTIPLE_THREADS: "gmail/threads/delete",
  MODIFY_MULTIPLE_THREADS: "gmail/threads/modify",
  MOVE_THREADS_TO_TRASH: "gmail/threads/thrash",
  MOVE_THREADS_FROM_TRASH: "gmail/threads/unthrash",
  GET_DRAFT_LIST: "user/draft/list/get",
  GET_GMAIL_INBOX_LIST: "user/thread/list/get",
  CREATE_DRAFT: "user/draft/create",
  UPDATE_DRAFT: "user/draft/modify/put",
  GET_MESSAGE_DETAIL: "user/message/details",
  SEND_EMAIL: "gmail/email/send",
  GET_ATTACHMENTS: "gmail/attachment/get",
  //////////////////////////people/////////////////////////////////////
  UNMAP_FAMILY_MEMBER: "user/family-member/split",
  CONVERT_MINOR_TO_MAJOR: "user/family-member/family-member-type/update",
  GET_PEOPLE_CLIENT_LIST: "user/client/all/get",
  GET_PEOPLE_CLIENT_FILTER_FOR_BULK_EMAIL_REVIEW:
    "user/client/filter/details/get",
  ADD_CLIENT: "user/client/add",
  EDIT_CLIENT: "user/client/edit",
  ADD_EDIT_CLIENT_ADDRESS: "user/address/add-edit",
  ADD_EDIT_CLIENT_BANK: "user/bank/add-edit",
  ADD_EDIT_CLIENT_DEMAT: "user/bank/demat/add-edit",
  GET_FAMILY_MEMBERS: "user/family-member/get",
  DELETE_FAMILY_MEMBER: "user/family-member/delete",
  ADD_FAMILY_MEMBER: "user/family-member/add",
  ADD_MULTIPLE_FAMILY_MEMBERS: "user/family-member/add/multiple",
  EDIT_FAMILY_MEMBER_BASIC_DETAILS_MORE_INFO: "user/family-member/edit",
  GET_COMPANY_PERSON_DETAILS: "user/client/company/person/get",
  SAVE_COMPANY_PERSON_DEATILS: "user/client/company/person/add",
  UPDATE_COMPANY_PERSON_DETAILS: "user/client/company/person/edit",
  TEAM_MEMBER_WISE_CLIENT_COUNT: "user/advisor/team-member/count/get",
  GET_TEAM_MEMBERS: "user/advisor/team-members/detail/get",
  GET_ADVISOR_FROM_EMAIL_MOBILE: "user/advisor/search/get",
  DELETE_CLIENT: "user/client/delete",
  GET_CLIENT_OR_lEAD_DATA: "user/client/detail/get",
  MERGE_CLIENT: "user/client/merge/client",
  SEARCH_CLIENT_BASED_ON_MOBILE: "user/client/search/mobile/get",
  SEARCH_CLIENT_BASED_ON_EMAIL: "user/client/search/email/get",
  UPDATE_CLIENT_STATUS: "user/client/status/update",
  GET_ADDRESS_LIST: "user/address/list/get",
  GET_DEMAT_LIST: "user/bank/demat/list/get",
  DELETE_EMAIL: "user/using-user-and-email-data/email/delete",
  GET_CLIENT_INFO_BASED_ON_USERNAME: "user/client/detail-using-uuid/get",
  RESET_LINK_EXPIRE: "user/client/reset-link/expire",
  // GET_BANK_LIST: 'user/bank/list/get',
  GET_BANK_LIST: "user/multiple-user/bank/list/get",
  GET_BANK_SINGLE_JOIN: "user/bank/list/based-on-holder/get",
  GET_CLIENT_FEMILY_BANK_LIST: "user/bank/list/all/get",
  SEND_WELCOME_EMAIL: "user/advisor/welcome/email/send",
  CREATE_TEAM_MEMBER: "user/advisor/team-member/sign-up",
  GET_ISD_CODES: "user/isd-code/list/get",
  GET_CLIENT_FAMILY_MEMBERS: "user/family-member/nominee/list/get",
  GET_CLIENT_FAMILY_MEMBER_LIST: "user/client/family/filter/get",
  GET_CLIENT_SEARCH_LIST: "user/client/filter/details/get",
  GET_CLIENT_FAMILY_MEMBER_LIST_ASSET: "user/family-member/list",
  GET_TEAM_MEMBER_INFO: "user/info/get",
  CHECK_VALID_USERNAME: "user/username/update",
  // CLIENT_SEARCH: 'user/client/all/names/get',
  CLIENT_SEARCH: "user/client/all/names/count/get",
  EDIT_BITHDATE: "user/client/birth-date/update",
  DELETE_ADDDRESS: "user/client/address/delete",
  DELETE_BANK: "user/client/bank-details/delete",
  DELETE_DEMAT: "user/client/demat/delete",
  GET_BANK_ACCOUNT_TYPE: "user/bank/account-type/global/get",
  GET_RELATIONSHIP_STATUS: "user/relationship/global/get",
  RESET_CLIENT_PASSWORD: "user/client/forced/reset/password",
  DISABLE_CLIENT_LOGIN: "user/client/enable/disable/login",
  GET_RANDOM_STRING: "user/advisor/marketplace-login/detail/add",
  GET_UNIQUE_STRING_FOR_LOGIN: "user/advisor/marketplace-login/detail/add",
  GENERATE_UUID_FOR_LOGIN: "user/generate/uuid",
  GET_LOGIN_DATA_FROM_RANDOM_STRING: "user/advisor/marketplace-login",
  MOVE_FAMILY_MEMBER: "user/family-member/move",
  MERGE_DUPLICATE_FAMILY_MEMBER: "user/client/merge/duplicate",
  PROMOTE_TO_CLIENT: "user/family-member/promote",
  KYC_LINK_SEND: "user/client/kyc-link/send",
  KYC_LINK_GET: "user/client/kyc-link/get",
  KYC_STATUS_UPDATE: "user/client/kyc-status/update",
  KYC_STATUS_OF_PAN: "user/kyc-status/get",
  GET_ADVSOR_NAME_MOBILE: "user/advisor/name-mobile/get",
  //////////////////////////////Login///////////////////////////////////
  GENERATE_OTP: "user/generate/login/otp",
  SAVE_AFTER_VERIFICATION: "user/email/mobile/save",
  REGISTER: "user/advisor/add",
  SEARCH_USERNAME: "user/search/username",
  SAVE_PASSWORD: "user/password/update",
  LOGIN_WITH_PASSWORD: "user/login/with/password",
  SUPPORT_LOGIN: "rmdashboard/rm/sign-in",
  RESET_PASSWORD: "setting/reset/password",
  GET_CLIENT_LOGO: "setting/organisation/domain/data/get",
  GET_BULK_EMAIL_PASSWORD_HISTORY: "setting/bulk/welcome-email/log-list/get",
  ADD_CALL_BACK_MOB: "advisor-callback-detail/add",
  GET_TEMPLATE_LIST: "plan/setting/financial-plan/advisor-template/list/get",
  ADD_TEMPLATE: "plan/financial-plan/template/add",
  EDIT_TEMPLATE: "plan/financial-plan/template/edit",
  SET_VISIBILITY: "plan/financial-plan/template/visibility/edit",
  RESET_TEMPLATE: "plan/financial-plan/advisor-template/reset",
  DELETE_TEMPLATE: "plan/financial-plan/template/delete",
  REMOVE_ACCESS_RIGHT: "setting/users-roles/access-rights/remove",
  ////////////////////////////// calendar////////////////////////////////////////////
  GET_EVENT: "calendar/event/list/get",
  GET_ATTENDY: "user/client/email/list/get",
  ADD_ATTENDY: "user/client/email/insert",
  GET_UPDATE: "calendar/event/update",
  GET_ADD: "calendar/event/add",
  GET_DELETE: "calendar/event/delete",

  GET_CALENDAR_HOLIDAY: "calendar/getHolidayList",
  GET_RM_PROFILE: "calendar/rmLanguageDetails/get",
  GET_RM_CALL_DETAILS: "rmdashboard/dashBoard/getAdvisorCallingDetails",
  GET_RM_CALL_UPCOMING_DATA: "rmdashboard/exotel/schedule/call/details",
  GET_RM_CALL_CURRENT_DATA: "rmdashboard/dashBoard/getCallLogs",
  GET_ADVISOR_DETAILS_COUNT:
    "rmdashboard/dashBoard/getAdvisorCallingCountDetails",
  CALL_BACK: "rmdashboard/callConnect",
  GET_KARVY_SUBUSER_RESPONE:
    "rmdashboard/select/club/advisor/subuser/option-id/get",

  ////////////////////////////// calendar////////////////////////////////////////////
  ///////////////////////////////Postal////////////////////////////////

  ////////////////////////////// settings////////////////////////////////////////////
  GET_PERSONAL_PROFILE: "setting/profile/personal/details/get",
  GET_ORG_PROFILE: "setting/profile/organisation/details/get",
  EDIT_PERSONAL_PROFILE: "setting/profile/personal/update",
  EDIT_ORG_PROFILE: "setting/profile/organisation/update",
  GET_PERSONAL_PROFILE_DETAILS: "setting/profile/personal/details/get",
  UPLOAD_PERSONAL_PROFILE_PHOTO:
    "setting/profile/personal/profile-photo/update",

  GET_ARN_RIA_GLOBAL_LIST: "setting/arn-ria/global/data/get",

  GET_ARN_RIA_LIST: "setting/arn-ria/list/get",
  GET_ARN_RIA_LIST_CHANGE: "setting/arn-ria/list/get/file/upload",
  ADD_ARN_RIA: "setting/back-office/arn-ria/add",
  EDIT_ARN_RIA: "setting/back-office/arn-ria/edit",
  GET_MF_RTA_LIST: "setting/arn-ria/rta/list/get",
  ADD_MF_RTA: "setting/arn-ria/rta/add",
  EDIT_MF_RTA: "setting/arn-ria/rta/edit",
  DELETE_MF_RTA: "setting/arn-ria/rta/delete",
  POST_MF_UPLOAD_CAS: "mutual-fund/upload/cas",
  GET_CLIENT_LATEST_CAS_FILE_LOG: "mutual-fund/client-latest/cas-log/get",
  GET_CLIENT_CAS_FILE_DETAIL_DATA: "mutual-fund/cas-upload-detail/get",
  PUT_MAP_INVESTOR_CAS: "mutual-fund/map/investor-mutualfund/update",
  PUT_MAP_TRANSACTION_CAS: "mutual-fund/map/mf-transaction/update",
  GET_STATUS_OF_CAS_FILE_UPLOAD: "mutual-fund/client/cas-log/list/get",
  GET_CAS_FILE_LOG_ON_REFRESH: "mutual-fund/cas-log/refresh/get",
  PUT_CAS_FILE_STATUS_UPDATE: "mutual-fund/cas-log/status/update",

  GET_USER_ROLES_GLOBAL_DATA: "setting/users/global/roles/get",

  GET_USER_ROLE_ROLE_LIST: "setting/users-roles/role/get",
  GET_ADVISOR_ROLE_ROLE_LIST: "setting/users-roles/advisor-role/get",
  EDIT_USER_ROLE: "setting/users-roles/role/edit",
  DELETE_USER_ROLE: "setting/users-roles/role/delete",
  CLONE_USER_ROLE: "setting/users-roles/role/clone/add",
  ADD_USER_ROLE: "setting/users-roles/role/add",
  GET_DETIALED_USER_ROLE: "setting/users-roles/role/module-detail/get",
  GET_TEMPLATE_ROLE:
    "setting/users-roles/role/advisor-or-client-role/template/get",

  GET_ALL_FEATURES: "setting/users-roles/feature-capabilities/all/get",

  GET_USER_ACCESS_RIGHTS_LIST: "setting/users-roles/access-rights/get",
  UPDATE_USER_ACCESS_RIGHTS: "setting/users-roles/access-rights/update",

  GET_ALL_TEAM_MEMBERS: "setting/users/team-members/get",
  ADD_TEAM_MEMBER: "setting/users/team-member/add",
  EDIT_TEAM_MEMBER: "setting/users/team-member/edit",
  DELETE_TEAM_MEMBER: "setting/users/team-member/delete",
  SUSPEND_TEAM_MEMBER: "setting/users/team-member/suspend",
  REACTIVATE_TEAM_MEMBER: "setting/users/team-member/resume",
  HAND_OVER_TEAM_MEMBER: "setting/users/team-member/hand-over/get",
  GET_CLIENT_OR_ADVISOR_ROLES: "setting/users-roles/role/module-loader/get",
  GET_DOMAIN_DATA: "setting/organisation/domain/data/get",
  RESET_TEAM_MEMBER_PASSWORD: "user/advisor/reset/password",
  ////////////////////////////// settings////////////////////////////////////////////
  //////////////////////////////////customer-overview-profile//////////////////////
  //////////////////////////////////customer-overview-myfeeds-profile//////////////////////
  GET_FEEDS_MF_DATA: "mutual-fund/latest/transaction/list/get",
  GET_DOCUMENTS_FEED: "document/account/document/total-count-and-size/get",
  GET_FEED_RISK_PROFILE: "plan/risk/profile/get",
  GET_GLOBAL_RISK_PROFILE: "plan/risk/profile/global/get",
  GET_FEED_RECENT_TRANSACTIONS: "report/transaction/list/get",
  GET_CASHFLOW_FEEDS: "cashflow/monthly/list/family-member-wise/get",
  GET_CUSTOMER_FEEDS_PROFILE: "user/client/profile/completeness/get",

  ///////////////////////////// To-DO list -dashboard //////////////////////////
  DASHBOARD_CHART: "account/asset/mutualfund/chart/get",
  ADD_NOTES: "admin/dashboard/memo/item/add",
  UPDATE_NOTES: "admin/dashboard/memo/item/update",
  DELETE_NOTES: "admin/dashboard/memo/item/delete",
  GET_NOTES: "admin/dashboard/memo/list/get",
  GET_BIRTHDAY_OR_ANNIVERSARY: "user/birthday/or/anniversary",
  KEY_METRICS_ADVISOR_DASHBOARD: "admin/dashboard/key/metrics",
  LAST_7_DAYS_TRANSACTION_STATUS: "report/transaction/status/summary",
  LAST_7_DAYS_TRANSACTION: "report/transaction/list/get",
  LAST_7_DAYS_TRANSACTION_NEW: "backoffice/mf-rejection-reversal/list/get",
  LAST_7_DAYS_INVESTMENT_ACCOUNTS: "user/register/filter/get",
  DOCUMENT_TOTAL_COUNT_SIZE:
    "document/account/document/total-count-and-size/get",
  LATEST_AUM_RECON: "admin/dashboard/aum/reconciliation/summary",
  GET_GOAL_SUMMARY: "admin/dashboard/goal/summary",
  GET_GOAL_SUMMARY_PLAN: "goal-planning/goal/plan/summary",
  GET_INSURANCE_SUMMARY_PLAN: "insurance/planning/list/get",
  GET_TASK_DASHBOARD_COUNT: "admin/dashboard/task/metrics/get",

  QUESTION_MASTER: "admin/dashboard/on-boarding/question-master",

  QUESTION_ANSWER_ADD: "admin/dashboard/on-boarding/question-answer/add",
  QUESTION_ANSWER_GET: "admin/dashboard/on-boarding/question-answer/get",
  ////////////////////////plan-summary///////////////////////////////////////
  GET_CASHFLOW: "plan/cash-flow/summary/get",
  ///////////////////////////// market place //////////////////////////
  GET_CALL_DETAILS: "marketplace/call/settings/get",
  ADD_CALL_DETAILS: "marketplace/call/settings/edit",
  ADD_CALL_AVAILABLE: "marketplace/call/settings/non-working/days/edit",
  GET_WEBPUSH_PUBLIC_KEY: "notification/public-signing-key/get",
  PUT_WEBPUSH_REGISTER_JSON: "notification/register/advisor",

  //////////////////////////// Lead interaction ///////////////////////
  POST_LEAD_INTERACTION_RESPONSE: "lead-first-interaction/add",
  REFERRED_USERS: "user/advisor/referrals/get",
  FROALA_UPLOAD_URL: "user/advisor/froala/file-upload?advisorId=",
  //////////////////////////////////////////////////////////////////////////

  GLOBAL_REMINDER_FILTER: "/reminder/global-data/get",
  GET_CLIENT_ASSIGNMENT: "user/client/unassigned/get",
  SENDY_LIST_GET: "misc/sendy/fw/list/get",
  ADD_SENDY_LIST: "misc/sendy/single/user/subscribe",
  DELETE_SENDY_LIST: "misc/sendy/single/user/delete",
  GET_RM_MASTER_LIST: "rmdashboard/dashboard/rm-master/user/get",
  APPEND_TO_SPREADSHEET: "sheet/entry/append",
  UPDATE_TO_SPREADSHEET: "sheet/entry/update",

  ////////////////////////////////////////////////////////////////////////
  GET_MOBILE_DETAIL_LIST: "rmdashboard/advisor/mobile-detail/list/get",
  ADD_ANDROID_DETAIL: "rmdashboard/advisor/android-detail/add",
  ADD_IOS_DETAIL: "rmdashboard/advisor/ios-detail/add",
  DELETE_ANDROID_DETAIL: "rmdashboard/advisor/android-detail/disable",
  DELETE_IOS_DETAIL: "rmdashboard/advisor/ios-detail/disable",
  GET_PAID_ADVISOR_LIST: "rmdashboard/paid-advisor/list/get",
  GET_JSON_UPLOAD_LINK: "rmdashboard/s3/google-service-key/file-upload/url/get",

  //------------------------ NEW APIS-------------------
  GET_AUM_DETAILS: "rm/reminder/aum/recon/get",
  UPDATE_RECON_REMINDER: "rm/reminder/aum/recon/aum/completed/status/update",
  UPDATE_CALL_STATUS: "rm/reminder/aum/recon/call/done/status/update",
  GET_AUM_COMMENT: "rm/reminder/aum/recon/comment/get",
  GET_COMMENTS_NEW: "rm/reminder/aum/recon/comment/get",
  ADD_COMMENTS_NEW: "rm/reminder/aum/recon/comment/add",
  GET_NJNEW_COMMENTS: "rmdashboard/nj/prudent/comment/get",
  ADD_NJ_NEW: "rmdashboard/nj/prudent/comment/add",

  GET_CAMS_LIST: "rm/reminder/cam/sched/get",
  GET_CAMS_ADVISOR: "rm/reminder/cams/reminder/advisor/name/get",
  GET_CAMS_ARN: "rm/reminder/cam/sched/arn/ria/number/get",
  ADD_CAMS: "rm/reminder/cams/sched/add/new/reminder/post",
  UPDATE_CAMS: "rm/reminder/cams/sched/completed/status/update",
  EDIT_DESC: "rm/reminder/cam/sched/desc/edit/put",
  GET_UUID: "generate/rm/uuid",
  GET_RM_UUID: "rm/login/with/uuid",
  GET_ROLES_DATA: "rmdashboard/support-role/module-loader/list/get",

  //--------------------Notification apis--------------------

  GET_TAGS_MASTER_LIST: "rmdashboard/notification/tags/master/list/get",
  GET_TYPE_MASTER_LIST: "rmdashboard/notification/type/master/list/get",
  ADD_NOTIFICATION_POST: "rmdashboard/notification/add/post",
  EDIT_NOTIFICATION_POST: "rmdashboard/notification/edit/post",
  GET_NOTIFICATION_LIST: "notification/support/short/list/get",
  GET_DETAILED_VIEW: "notification/detail/view/get",

  GET_TABLE_DATA: "rmdashboard/advisor/data/get",
  DATA_CLEANUP: "rmdashboard/advisor/data-cleanup",
  GET_LOG_DATA: "rmdashboard/delete/utility/log",
  UPDATE_PROCESS_STATUS: "rmdashboard/delete/utility/status",
  GET_AMC_LIST: "rmdashboard/delete/utility/amc-filter",
  GOAL_BACKUP: "rmdashboard/delete/utility/goal/backup",
  //--------------------add-ons apis--------------------
  GET_BILLING_ADDONS_DETAILS: "billing/add-on/get",
  ADD_ON_ADD_EDIT: "user/advisor/Add-on/addOrEdit",
  //------------------SIP-Recon----------------------
  GET_MAIN_TABLE_DATA: "mutual-fund/bulk/sip/recon/list/get",
  GET_MAIN_TABLE_ADVISOR_LIST: "mutual-fund/bulk/sip/recon/advisor/list",
  GET_ACTIVITY_TABLE_DATA: "mutual-fund/bulk/sip/recon/log",
  GET_CASES_DETAIL_DATA: "mutual-fund/bulk/sip/recon/cases/list/get",
  GET_SIP_RECONCILATION_TRANSACTION:
    "mutual-fund/sip/recon/transaction/list/get",
  POST_IGNORE: "mutual-fund/sip/recon/transaction/ignore",
  POST_RESTORE: "mutual-fund/sip/recon/transaction/restore",
  GET_SIP_RECONCILATION_MASTER: "mutual-fund/sip/recon/master/list/get",
  FREEZE_SIP: "mutual-fund/bulk/sip/recon/freeze",
  GET_ORDER_SUMMARY_TABLE_DATA:
    "mutual-fund/bulk/sip/recon/order/summary/list/get",
  ORDER_SUMMARY_PAGE_ADVISOR_LIST:
    "mutual-fund/bulk/sip/recon/order/summary/advisor/list",
  ORDER_ACTIVITY_LOG_ADVISOR_LIST:
    "mutual-fund/bulk/sip/recon/log/advisor/list",
  FILEORDER_SELECTCLUB: "fileorder/select-club/historical/order",
  SELECT_CLUB_ADVSIOR_LIST: "fileorder/select/club/historical/advisor/list/get",
  FILE_NOT_TO_ORDER_SELECTCLUB:
    "fileorder/select-club/enabled/disabled/list/get",
  FILEORDER_DATA_SAVE: "fileorder/select-club/historic/order/enabled/disabled",

  /*-----------Ifa Onboarding----------- */
  GET_IFA_DETAILS: "rmdashboard/myifas/dashboard/details/Filter/get",
  GET_IFA_QUESTION_COUNT: "rmdashboard/dashBoard/questionCount",

  GET_SEARCH_LIST: "rmdashboard/exotel/advisor/search",
  SCHEDULE_CALL: "rmdashboard/dashboard/scheduleCall",
  AUTOMATIC_CALL: "rmdashboard/exotel-retry/calls",
  // demoschedule apis

  GET_RM_SLOT_LIST: "calendar/slotDetails/get",
  GET_UPCOMING_DEMO: "calendar/upComingDemo/get",
  GET_PAST_DEMO: "calendar/pastDemo/get",
  GET_RM_UMAVAILABILITY_DATA: "calendar/rmUnAvailability/get",
  DELETE_SLOT: "calendar/rmAvailability/delete",
  EDIT_UNAVAILIBILITY: "calendar/rmAvailability/update",
  ADD_UNAVAILIBILITY: "calendar/addUnavailability",
  UNAVAILABLE_SLOTS: "calendar/unavailableslotDetails/get",
  /*-----------------AUM RECON-----------------------*/
  GET_AUM_RECON_SCHEDULE_LIST: "rmdashboard/schedule/list",
  GET_AUM_RECON_ADVISOR_LIST: "rmdashboard/advisor/list",
  REFRESH_AUM_RECON: "rmdashboard/aum-recon-schedule/refresh",
  DOWNLOAD_AUM_RECON: "rmdashboard/aum-recon/file/download/url",
  OPS_TEAM: "rmdashboard/aum-recon/rm-assigned/list/get",
  BEFORE_RECO_EXPORT_TO_EXCEL:
    "rmdashboard/aum-recon/unmatched/folios/list/get",
  GET_INITIAL_ONBOARDING_COMMENTS:
    "rmdashboard/ifa/onboarding/initial-comments/get",
  GET_DEACTIVATE_REASON_LIST: "rmdashboard/ifa/deactivation/reason/get",
  POST_DEACTIVATE_REASON_LIST: "rmdashboard/ifa/deactivation/reason/update",
  POST_INITIAL_ONBOARDING_COMMENTS: "rmdashboard/initial-comments/update",

  /* -------Empanelment Section -------------*/
  GET_EMPANELMENT_DETAILS: "account/asset/empanelment/advisor/list/get",
  GET_EMPANELMENT_DOC: "account/asset/empanelment/doc-details/get",
  GET_EMPANELMENT_SIDEBAR_DETAILS: "account/asset/empanelment/form-detail/get",

  // ----------Commissions API -------------------
  GET_COMMISSION_PLANS: "rmdashboard/commissions/plan/edit",
  GET_COMMISSION_TABLE: "rmdashboard/commissions/get",
  GET_COMMISSION_PLAN_PREVIEW: "rmdashboard/commissions/plan/preview",
  CHECK_PASSWORD: "rmdashboard/commissions/plan/auth",
  SET_COMMISSION_PLANS: "rmdashboard/commissions/plan/set",
  GET_COMMISSION_SUMMARY: "rmdashboard/commissions/plan/get",
  GET_DETAILED_VIEW_COMMISSION: "rmdashboard/commissions/plan/detailed-view",
  GET_REPORT_DOWNLOAD_COMMISSION: "rmdashboard/commissions/plan/download",
  // GET_EMPANELMENT_DETAILS: 'account/asset/empanelment/advisor/list/get',
  // GET_EMPANELMENT_SIDEBAR_DETAILS: 'account/asset/empanelment/form-detail/get',
  GET_EMPANELMENT_DOCUMENT_MASTER: 'account/asset/empanelment/doc-type/get',
  // GET_EMPANELMENT_DOC: 'account/asset/empanelment/doc-details/get',
  S3_DOC_UPLOAD: 'backoffice/s3/file-upload/url/get',
  SUBMIT_EMPANELMENT_DOC: 'account/asset/empanelment/doc/add-edit',
  SUBMIT_EMPANELMENT_FORM: 'account/asset/empanelment/form/insert-update',
  DOWNLOAD_FILE_EMPANELMENT: 'file/download-url/get',
  GET_EMPANELMENT_COMPLETED: 'account/asset/empanelment/product-master/get',

};
